import React, { useState, useEffect, useMemo } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Checkbox } from '../../components/ui/checkbox';
import { Button } from '../../components/ui/button';
import { Trophy, Users, Award, Star, Loader2, Check, CheckCircle2, MessageCircle, Send, Copy, ExternalLink, TrendingUp, UserCheck, ChevronLeft, ChevronRight, ArrowLeft, ChevronDown, ChevronUp, Edit, Eye, UserX } from 'lucide-react';
import { getAllAwards, getMyNominations, submitNominations, sendAppPromotionWhatsApp, getMyReferralContacts, getMyReferralStats, getTeamNominations, getAllNominationsAdmin, getHighestAppDownloads, getHighestAppDownloadsByTeam, getHighestApproachAward, getHighestApproachesByTeam, getHighestCollegeReferralsByTeam, getHighestCompanyReferralsByTeam, getHighestJobPostsCreatedByTeam, getHighestJoiningsByTeam, getHighestSelectionsByTeam, getHighestInternsAddedByTeam, getHighestTalentPoolCreationByTeam, getHighestWalkInsByTeam, getHighestSubjobPostCreation, getHighestJoiningsAward, getHighestSelectionsAward, getHighestWalkInsAward, getHighestTalentPoolCreationAward, getHighestCollegeReferralAward, getHighestCompanyReferralAward, getRegisteredUsersWithNominations, getUnregisteredActiveUsers, IAward, INomination, IReferralContact, ITeamNomination, IPopulatedNomination, IHighestAppDownload, IHighestAppDownloadsByTeam, IHighestApproachAward, IHighestApproachesByTeam, IHighestCollegeReferralsByTeam, IHighestCompanyReferralsByTeam, IHighestJobPostsCreatedByTeam, IHighestJoiningsByTeam, IHighestSelectionsByTeam, IHighestInternsAddedByTeam, IHighestTalentPoolCreationByTeam, IHighestWalkInsByTeam, IHighestSubjobPostCreation, IHighestJoiningsAward, IHighestSelectionsAward, IHighestWalkInsAward, IHighestTalentPoolCreationAward, IHighestCollegeReferralAward, IHighestCompanyReferralAward, IRegisteredUserWithNominations } from '../../services/awardApi';
import { toast } from 'react-hot-toast';
import { useRbac } from '../../context';
import * as XLSX from 'xlsx';
import { format } from 'date-fns';
import { Download } from 'lucide-react';

interface AwardCategory {
  id: string;
  name: string;
  checked: boolean;
  description?: string;
}

const RecruitmentMahakumb = () => {
  const { user, setUser } = useRbac();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [individualAwards, setIndividualAwards] = useState<AwardCategory[]>([]);
  const [teamAwards, setTeamAwards] = useState<AwardCategory[]>([]);
  const [influencerAwards, setInfluencerAwards] = useState<AwardCategory[]>([]);
  const [commonAwards, setCommonAwards] = useState<AwardCategory[]>([]);
  const [nominations, setNominations] = useState<INomination[]>([]);
  const [submittedNominations, setSubmittedNominations] = useState<INomination[]>([]);
  const [whatsappNumbers, setWhatsappNumbers] = useState<string>('');
  const [sendingWhatsApp, setSendingWhatsApp] = useState(false);
  const [successfulReferrals, setSuccessfulReferrals] = useState<IReferralContact[]>([]);
  const [loadingReferrals, setLoadingReferrals] = useState(false);
  const [referralStats, setReferralStats] = useState<{ totalSent: number; accountCreated: number } | null>(null);
  const [referralPage, setReferralPage] = useState(1);
  const [referralLimit] = useState(10);
  const [referralPagination, setReferralPagination] = useState<{
    totalResults: number;
    page: number;
    limit: number;
    totalPages: number;
  } | null>(null);
  const [viewMode, setViewMode] = useState<'main' | 'teamNominations' | 'allNominations' | 'viewResult' | 'registeredUsers' | 'unregisteredUsers'>('main');
  const [teamNominations, setTeamNominations] = useState<ITeamNomination[]>([]);
  const [teamNominationsLoading, setTeamNominationsLoading] = useState(false);
  const [teamNominationsPage, setTeamNominationsPage] = useState(1);
  const [teamNominationsLimit] = useState(10);
  const [teamNominationsSearch, setTeamNominationsSearch] = useState('');
  const [teamNominationsPagination, setTeamNominationsPagination] = useState<{
    totalResults: number;
    page: number;
    limit: number;
    totalPages: number;
  } | null>(null);
  const [expandedUsers, setExpandedUsers] = useState<Set<string>>(new Set());
  const [allTeamNominations, setAllTeamNominations] = useState<ITeamNomination[]>([]);
  const [userPaginationPage, setUserPaginationPage] = useState(1);
  const [userPaginationLimit] = useState(10);
  const [allNominations, setAllNominations] = useState<IPopulatedNomination[]>([]);
  const [allNominationsLoading, setAllNominationsLoading] = useState(false);
  const [allNominationsPage, setAllNominationsPage] = useState(1);
  const [allNominationsLimit] = useState(25);
  const [allNominationsSearch, setAllNominationsSearch] = useState('');
  const [allNominationsPagination, setAllNominationsPagination] = useState<{
    totalResults: number;
    page: number;
    limit: number;
    totalPages: number;
  } | null>(null);
  const [allAwardsList, setAllAwardsList] = useState<IAward[]>([]);
  const [selectedAwardId, setSelectedAwardId] = useState<string | undefined>(undefined);
  const [leadingWinners, setLeadingWinners] = useState<IHighestAppDownload[]>([]);
  const [leadingWinnersLoading, setLeadingWinnersLoading] = useState(false);
  const [teamAppDownloadsWinners, setTeamAppDownloadsWinners] = useState<IHighestAppDownloadsByTeam[]>([]);
  const [teamAppDownloadsWinnersLoading, setTeamAppDownloadsWinnersLoading] = useState(false);
  const [teamApproachesWinners, setTeamApproachesWinners] = useState<IHighestApproachesByTeam[]>([]);
  const [teamApproachesWinnersLoading, setTeamApproachesWinnersLoading] = useState(false);
  const [teamCollegeReferralsWinners, setTeamCollegeReferralsWinners] = useState<IHighestCollegeReferralsByTeam[]>([]);
  const [teamCollegeReferralsWinnersLoading, setTeamCollegeReferralsWinnersLoading] = useState(false);
  const [teamCompanyReferralsWinners, setTeamCompanyReferralsWinners] = useState<IHighestCompanyReferralsByTeam[]>([]);
  const [teamCompanyReferralsWinnersLoading, setTeamCompanyReferralsWinnersLoading] = useState(false);
  const [teamJobPostsWinners, setTeamJobPostsWinners] = useState<IHighestJobPostsCreatedByTeam[]>([]);
  const [teamJobPostsWinnersLoading, setTeamJobPostsWinnersLoading] = useState(false);
  const [teamJoiningsWinners, setTeamJoiningsWinners] = useState<IHighestJoiningsByTeam[]>([]);
  const [teamJoiningsWinnersLoading, setTeamJoiningsWinnersLoading] = useState(false);
  const [teamSelectionsWinners, setTeamSelectionsWinners] = useState<IHighestSelectionsByTeam[]>([]);
  const [teamSelectionsWinnersLoading, setTeamSelectionsWinnersLoading] = useState(false);
  const [teamInternsAddedWinners, setTeamInternsAddedWinners] = useState<IHighestInternsAddedByTeam[]>([]);
  const [teamInternsAddedWinnersLoading, setTeamInternsAddedWinnersLoading] = useState(false);
  const [teamTalentPoolCreationWinners, setTeamTalentPoolCreationWinners] = useState<IHighestTalentPoolCreationByTeam[]>([]);
  const [teamTalentPoolCreationWinnersLoading, setTeamTalentPoolCreationWinnersLoading] = useState(false);
  const [teamWalkInsWinners, setTeamWalkInsWinners] = useState<IHighestWalkInsByTeam[]>([]);
  const [teamWalkInsWinnersLoading, setTeamWalkInsWinnersLoading] = useState(false);
  const [approachWinners, setApproachWinners] = useState<IHighestApproachAward[]>([]);
  const [approachWinnersLoading, setApproachWinnersLoading] = useState(false);
  const [subjobWinners, setSubjobWinners] = useState<IHighestSubjobPostCreation[]>([]);
  const [subjobWinnersLoading, setSubjobWinnersLoading] = useState(false);
  const [joiningsWinners, setJoiningsWinners] = useState<IHighestJoiningsAward[]>([]);
  const [joiningsWinnersLoading, setJoiningsWinnersLoading] = useState(false);
  const [selectionsWinners, setSelectionsWinners] = useState<IHighestSelectionsAward[]>([]);
  const [selectionsWinnersLoading, setSelectionsWinnersLoading] = useState(false);
  const [walkInsWinners, setWalkInsWinners] = useState<IHighestWalkInsAward[]>([]);
  const [walkInsWinnersLoading, setWalkInsWinnersLoading] = useState(false);
  const [talentPoolWinners, setTalentPoolWinners] = useState<IHighestTalentPoolCreationAward[]>([]);
  const [talentPoolWinnersLoading, setTalentPoolWinnersLoading] = useState(false);
  const [collegeReferralWinners, setCollegeReferralWinners] = useState<IHighestCollegeReferralAward[]>([]);
  const [collegeReferralWinnersLoading, setCollegeReferralWinnersLoading] = useState(false);
  const [companyReferralWinners, setCompanyReferralWinners] = useState<IHighestCompanyReferralAward[]>([]);
  const [companyReferralWinnersLoading, setCompanyReferralWinnersLoading] = useState(false);
  const [registeredUsers, setRegisteredUsers] = useState<IRegisteredUserWithNominations[]>([]);
  const [registeredUsersLoading, setRegisteredUsersLoading] = useState(false);
  const [registeredUsersPage, setRegisteredUsersPage] = useState(1);
  const [registeredUsersLimit] = useState(10);
  const [registeredUsersSearch, setRegisteredUsersSearch] = useState('');
  const [registeredUsersPagination, setRegisteredUsersPagination] = useState<{
    totalResults: number;
    page: number;
    limit: number;
    totalPages: number;
  } | null>(null);
  const [unregisteredUsers, setUnregisteredUsers] = useState<IRegisteredUserWithNominations[]>([]);
  const [unregisteredUsersLoading, setUnregisteredUsersLoading] = useState(false);
  const [unregisteredUsersPage, setUnregisteredUsersPage] = useState(1);
  const [unregisteredUsersLimit] = useState(10);
  const [unregisteredUsersSearch, setUnregisteredUsersSearch] = useState('');
  const [unregisteredUsersPagination, setUnregisteredUsersPagination] = useState<{
    totalResults: number;
    page: number;
    limit: number;
    totalPages: number;
  } | null>(null);
  
  // Generate personalized app link with UTM parameters based on user
  const appLink = useMemo(() => {
    const baseUrl = 'https://app.earlyjobs.ai/';
    const params = new URLSearchParams({
      utm_source: 'recruitment_mahakumb',
      utm_content: user?.id || 'user',
    });
    return `${baseUrl}?${params.toString()}`;
  }, [user]);

  // Toggle user expansion
  const toggleUserExpansion = (userId: string) => {
    setExpandedUsers(prev => {
      const newSet = new Set(prev);
      if (newSet.has(userId)) {
        newSet.delete(userId);
      } else {
        newSet.add(userId);
      }
      return newSet;
    });
  };

  // Expand all users
  const expandAllUsers = () => {
    const groupedNominations = allTeamNominations.reduce((acc, nomination) => {
      const userId = nomination.userId;
      if (!acc[userId]) {
        acc[userId] = true;
      }
      return acc;
    }, {} as Record<string, boolean>);
    setExpandedUsers(new Set(Object.keys(groupedNominations)));
  };

  // Collapse all users
  const collapseAllUsers = () => {
    setExpandedUsers(new Set());
  };

  // Render Team Nominations Screen
  const renderTeamNominationsScreen = () => {
    // Group nominations by user
    const groupedNominations = allTeamNominations.reduce((acc, nomination) => {
      const userId = nomination.userId;
      if (!acc[userId]) {
        acc[userId] = {
          userId: nomination.userId,
          username: nomination.username,
          userEmail: nomination.userEmail,
          userPhone: nomination.userPhone,
          userRole: nomination.userRole,
          nominations: [],
        };
      }
      acc[userId].nominations.push({
        awardName: nomination.awardName,
        awardCategory: nomination.awardCategory,
        createdAt: nomination.createdAt,
      });
      return acc;
    }, {} as Record<string, { userId: string; username: string; userEmail: string; userPhone?: string; userRole: string; nominations: Array<{ awardName: string; awardCategory: string; createdAt: string }> }>);

    const allGroupedUsers = Object.values(groupedNominations);
    
    // Sort users by latest nomination date (most recent first)
    allGroupedUsers.sort((a, b) => {
      const aLatest = Math.max(...a.nominations.map(n => new Date(n.createdAt).getTime()));
      const bLatest = Math.max(...b.nominations.map(n => new Date(n.createdAt).getTime()));
      return bLatest - aLatest;
    });

    // Calculate pagination for users
    const totalUsers = allGroupedUsers.length;
    const totalUserPages = Math.ceil(totalUsers / userPaginationLimit);
    const startIndex = (userPaginationPage - 1) * userPaginationLimit;
    const endIndex = startIndex + userPaginationLimit;
    const groupedData = allGroupedUsers.slice(startIndex, endIndex);

    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-orange-50/40 p-4 sm:p-6">
        <div className="max-w-7xl mx-auto space-y-6">
          {/* Header with Back Button */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="outline"
                onClick={() => setViewMode('main')}
                className="bg-white hover:bg-gray-50 border-gray-300"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back
              </Button>
              <div className="flex items-center gap-3">
                <Users className="h-6 w-6 text-[#EC6E51]" />
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                  My Team Nominations
                </h1>
              </div>
            </div>
          </div>

          {/* Search Bar and Controls */}
          <Card className="border border-gray-200 shadow-sm">
            <CardContent className="p-4">
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <input
                  type="text"
                  placeholder="Search by name, email, phone, or award..."
                  value={teamNominationsSearch}
                  onChange={(e) => {
                    setTeamNominationsSearch(e.target.value);
                    setUserPaginationPage(1); // Reset to first page on search
                  }}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#EC6E51] focus:border-transparent"
                />
                <div className="flex gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={expandAllUsers}
                    className="bg-white hover:bg-gray-50 text-xs"
                  >
                    <ChevronDown className="h-4 w-4 mr-1" />
                    Expand All
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={collapseAllUsers}
                    className="bg-white hover:bg-gray-50 text-xs"
                  >
                    <ChevronUp className="h-4 w-4 mr-1" />
                    Collapse All
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Summary Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Card className="border border-gray-200 shadow-sm">
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Team Members</p>
                    <p className="text-3xl font-bold text-gray-900">
                      {groupedData.length}
                    </p>
                  </div>
                  <Users className="h-10 w-10 text-[#EC6E51] opacity-20" />
                </div>
              </CardContent>
            </Card>
            <Card className="border border-gray-200 shadow-sm">
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Total Nominations</p>
                    <p className="text-3xl font-bold text-gray-900">
                      {allTeamNominations.length}
                    </p>
                  </div>
                  <Award className="h-10 w-10 text-[#EC6E51] opacity-20" />
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Loading State */}
          {teamNominationsLoading ? (
            <Card className="border border-gray-200 shadow-sm">
              <CardContent className="p-12 text-center">
                <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                <p className="text-lg font-semibold text-gray-600">Loading team nominations...</p>
              </CardContent>
            </Card>
          ) : (
            <>
              {/* Team Members List */}
              <div className="space-y-4">
                {groupedData.length === 0 ? (
                  <Card className="border border-gray-200 shadow-sm">
                    <CardContent className="p-12 text-center">
                      <Users className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                      <p className="text-lg font-semibold text-gray-600 mb-2">No team nominations found</p>
                      <p className="text-sm text-gray-500">
                        {teamNominationsSearch 
                          ? 'Try adjusting your search criteria.'
                          : 'Team members will appear here once they submit their nominations.'}
                      </p>
                    </CardContent>
                  </Card>
                ) : (
                  groupedData.map((user) => {
                    const isExpanded = expandedUsers.has(user.userId);
                    return (
                      <Card key={user.userId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardHeader className="bg-gradient-to-r from-gray-50 to-white border-b border-gray-200 cursor-pointer" onClick={() => toggleUserExpansion(user.userId)}>
                          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                            <div className="flex items-center gap-4 flex-1">
                              <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#EC6E51] to-[#E66A4E] flex items-center justify-center text-white font-semibold text-base flex-shrink-0">
                                {user.username.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()}
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="text-lg font-semibold text-gray-900">{user.username}</p>
                                <div className="flex flex-wrap items-center gap-2 mt-1">
                                  <span className="text-xs px-2.5 py-1 rounded bg-blue-100 text-blue-700 font-medium">{user.userRole}</span>
                                  {user.userPhone && (
                                    <>
                                      <span className="text-xs text-gray-500">·</span>
                                      <span className="text-sm text-gray-600">{user.userPhone}</span>
                                    </>
                                  )}
                                </div>
                                <p className="text-xs text-gray-500 mt-1 truncate">{user.userEmail}</p>
                              </div>
                            </div>
                            <div className="flex items-center gap-4">
                              <div className="text-left sm:text-right">
                                <p className="text-xs text-gray-500 font-medium mb-1">Latest Submission</p>
                                <p className="text-sm text-gray-700 font-semibold">
                                  {new Date(Math.max(...user.nominations.map(n => new Date(n.createdAt).getTime()))).toLocaleString('en-IN', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                  })}
                                </p>
                              </div>
                              <Button
                                variant="ghost"
                                size="sm"
                                className="ml-2 p-2 hover:bg-gray-100 rounded-full transition-transform"
                                style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
                              >
                                <ChevronDown className="h-5 w-5 text-gray-600" />
                              </Button>
                            </div>
                          </div>
                        </CardHeader>
                        
                        {/* Accordion Content */}
                        <div 
                          className="overflow-hidden transition-all duration-300 ease-in-out"
                          style={{ 
                            maxHeight: isExpanded ? '2000px' : '0px',
                            opacity: isExpanded ? 1 : 0
                          }}
                        >
                          <CardContent className="py-5">
                            <div className="flex items-center gap-2 mb-4">
                              <Award className="h-5 w-5 text-[#EC6E51]" />
                              <span className="text-base font-semibold text-gray-700">Nominations ({user.nominations.length})</span>
                            </div>
                            <div className="space-y-3">
                              {user.nominations.map((nomination, idx) => (
                                <div key={idx} className="flex items-start gap-3 p-3 rounded-lg bg-gradient-to-r from-orange-50 to-orange-100 border border-orange-200">
                                  <Trophy className="h-5 w-5 text-yellow-600 mt-0.5 flex-shrink-0" />
                                  <div className="flex-1">
                                    <p className="text-base font-semibold text-gray-900">{nomination.awardName}</p>
                                    <p className="text-sm text-gray-600 mt-1">Category: {nomination.awardCategory}</p>
                                    <p className="text-xs text-gray-500 mt-2">
                                      Submitted: {new Date(nomination.createdAt).toLocaleString('en-IN', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                      })}
                                    </p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </CardContent>
                        </div>
                      </Card>
                    );
                  })
                )}
              </div>

              {/* Pagination - Based on Users */}
              {totalUserPages > 1 && (
                <Card className="border border-gray-200 shadow-sm">
                  <CardContent className="p-4">
                    <div className="flex items-center justify-between">
                      <Button
                        variant="outline"
                        onClick={() => setUserPaginationPage(prev => Math.max(1, prev - 1))}
                        disabled={userPaginationPage === 1}
                        className="bg-white hover:bg-gray-50"
                      >
                        <ChevronLeft className="h-4 w-4 mr-2" />
                        Previous
                      </Button>
                      <span className="text-sm text-gray-600">
                        Page {userPaginationPage} of {totalUserPages} ({totalUsers} users)
                      </span>
                      <Button
                        variant="outline"
                        onClick={() => setUserPaginationPage(prev => Math.min(totalUserPages, prev + 1))}
                        disabled={userPaginationPage === totalUserPages}
                        className="bg-white hover:bg-gray-50"
                      >
                        Next
                        <ChevronRight className="h-4 w-4 ml-2" />
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  // Fetch referral data
  const fetchReferralData = async (page: number = referralPage) => {
    try {
      setLoadingReferrals(true);
      const [referralsData, statsData] = await Promise.all([
        getMyReferralContacts(page, referralLimit).catch(() => ({ referrals: [], metadata: { totalResults: 0, page: 1, limit: referralLimit, totalPages: 0 } })),
        getMyReferralStats().catch(() => null),
      ]);
      setSuccessfulReferrals(referralsData.referrals);
      setReferralPagination(referralsData.metadata);
      if (statsData) {
        setReferralStats({
          totalSent: statsData.totalSent,
          accountCreated: statsData.accountCreated,
        });
      }
    } catch (error) {
      console.error('Error fetching referral data:', error);
    } finally {
      setLoadingReferrals(false);
    }
  };

  // Handle referral page change
  const handleReferralPageChange = (newPage: number) => {
    setReferralPage(newPage);
    fetchReferralData(newPage);
  };

  // Fetch all team nominations (for client-side user pagination)
  const fetchTeamNominations = async () => {
    try {
      setTeamNominationsLoading(true);
      // Fetch with a large limit to get all nominations, then paginate users on client
      const { nominations, metadata } = await getTeamNominations({
        page: 1,
        limit: 1000, // Large limit to get all nominations
        search: teamNominationsSearch || undefined,
      });
      setAllTeamNominations(nominations);
      // Update pagination metadata based on total nominations
      setTeamNominationsPagination(metadata);
    } catch (error) {
      console.error('Error fetching team nominations:', error);
      setAllTeamNominations([]);
    } finally {
      setTeamNominationsLoading(false);
    }
  };

  // Fetch team nominations when view mode changes or search changes
  useEffect(() => {
    if (viewMode === 'teamNominations') {
      fetchTeamNominations();
      setUserPaginationPage(1); // Reset to first page when fetching new data
    }
  }, [viewMode, teamNominationsSearch]);

  // Fetch awards and nominations on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // If user has already submitted, fetch their nominations and referrals
        if (user?.isMahkumbnominationSubmitted) {
          const [nominationsData] = await Promise.all([
            getMyNominations().catch(() => []),
            fetchReferralData(),
          ]);
          setSubmittedNominations(nominationsData);
          setLoading(false);
          return;
        }

        // Otherwise, fetch awards for selection
        const [awardsData, nominationsData] = await Promise.all([
          getAllAwards(),
          getMyNominations().catch(() => []) // Don't fail if nominations fail
        ]);

        // Create a set of nominated award IDs for quick lookup
        const nominatedAwardIds = new Set(
          nominationsData.map((nom: INomination) => {
            const awardId = typeof nom.awardId === 'string' ? nom.awardId : nom.awardId._id;
            return awardId;
          })
        );

        // Group awards by category and mark as checked if nominated
        const individual: AwardCategory[] = [];
        const team: AwardCategory[] = [];
        const influencer: AwardCategory[] = [];
        const common: AwardCategory[] = [];

        awardsData.forEach((award: IAward) => {
          const awardItem: AwardCategory = {
            id: award._id,
            name: award.name,
            checked: nominatedAwardIds.has(award._id),
            description: award.description,
          };

          switch (award.category) {
            case 'Individual Winner':
              individual.push(awardItem);
              break;
            case 'Team Winner':
              team.push(awardItem);
              break;
            case 'Influencer Award':
              influencer.push(awardItem);
              break;
            case 'Common Award':
              common.push(awardItem);
              break;
          }
        });

        setIndividualAwards(individual);
        setTeamAwards(team);
        setInfluencerAwards(influencer);
        setCommonAwards(common);
        setNominations(nominationsData);
      } catch (error) {
        console.error('Error fetching awards:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user?.isMahkumbnominationSubmitted]);

  // Handle checkbox changes - only update local state
  const handleIndividualChange = (id: string, checked: boolean) => {
    setIndividualAwards(prev =>
      prev.map(award => award.id === id ? { ...award, checked } : award)
    );
  };

  const handleTeamChange = (id: string, checked: boolean) => {
    setTeamAwards(prev =>
      prev.map(award => award.id === id ? { ...award, checked } : award)
    );
  };

  const handleInfluencerChange = (id: string, checked: boolean) => {
    setInfluencerAwards(prev =>
      prev.map(award => award.id === id ? { ...award, checked } : award)
    );
  };

  const handleCommonChange = (id: string, checked: boolean) => {
    setCommonAwards(prev =>
      prev.map(award => award.id === id ? { ...award, checked } : award)
    );
  };

  // Submit nominations
  const handleSubmitNominations = async () => {
    try {
      setSubmitting(true);

      // Get all currently checked awards
      const allAwards = [
        ...individualAwards,
        ...teamAwards,
        ...influencerAwards,
        ...commonAwards,
      ];

      const checkedAwardIds = new Set(
        allAwards.filter(award => award.checked).map(award => award.id)
      );

      // Get currently nominated award IDs
      const currentNominatedIds = new Set(
        nominations.map((nom: INomination) => {
          const awardId = typeof nom.awardId === 'string' ? nom.awardId : nom.awardId._id;
          return awardId;
        })
      );

      // Awards to create nominations for (checked but not yet nominated)
      const awardsToCreate = Array.from(checkedAwardIds).filter(
        id => !currentNominatedIds.has(id)
      );

      // Awards to delete nominations for (nominated but not checked)
      const awardsToDelete = Array.from(currentNominatedIds).filter(
        id => !checkedAwardIds.has(id)
      );

      // Submit nominations using batch API
      const result = await submitNominations(awardsToCreate, awardsToDelete);

      // Refresh user data to get updated isMahkumbnominationSubmitted flag
      const { getCurrentUserDetails } = await import('../../services/apiclient');
      const userData = await getCurrentUserDetails();
      if (userData.data.user && setUser) {
        setUser({
          ...user,
          ...userData.data.user,
          isMahkumbnominationSubmitted: true,
        } as any);
      }

      // Set submitted nominations
      setSubmittedNominations(result.nominations);

      // Show success message
      const createdCount = result.created;
      const deletedCount = result.deleted;
      
      if (createdCount > 0 || deletedCount > 0) {
        let message = 'Nominations submitted successfully!';
        if (createdCount > 0 && deletedCount > 0) {
          message = `${createdCount} nomination(s) created and ${deletedCount} nomination(s) removed.`;
        } else if (createdCount > 0) {
          message = `${createdCount} nomination(s) submitted successfully!`;
        } else if (deletedCount > 0) {
          message = `${deletedCount} nomination(s) removed successfully!`;
        }
        toast.success(message);
      } else {
        toast.success('No changes to submit.');
      }
    } catch (error: any) {
      console.error('Error submitting nominations:', error);
      toast.error(error.response?.data?.message || 'Failed to submit nominations. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  // Handle edit nomination - reset to allow editing
  const handleEditNomination = async () => {
    try {
      // Reset submitted state
      if (setUser && user) {
        setUser({
          ...user,
          isMahkumbnominationSubmitted: false,
        } as any);
      }
      setSubmittedNominations([]);
      
      // Reload awards and nominations
      setLoading(true);
      const [awardsData, nominationsData] = await Promise.all([
        getAllAwards(),
        getMyNominations().catch(() => [])
      ]);

      const nominatedAwardIds = new Set(
        nominationsData.map((nom: INomination) => {
          const awardId = typeof nom.awardId === 'string' ? nom.awardId : nom.awardId._id;
          return awardId;
        })
      );

      const individual: AwardCategory[] = [];
      const team: AwardCategory[] = [];
      const influencer: AwardCategory[] = [];
      const common: AwardCategory[] = [];

      awardsData.forEach((award: IAward) => {
        const awardItem: AwardCategory = {
          id: award._id,
          name: award.name,
          checked: nominatedAwardIds.has(award._id),
          description: award.description,
        };

        switch (award.category) {
          case 'Individual Winner':
            individual.push(awardItem);
            break;
          case 'Team Winner':
            team.push(awardItem);
            break;
          case 'Influencer Award':
            influencer.push(awardItem);
            break;
          case 'Common Award':
            common.push(awardItem);
            break;
        }
      });

      setIndividualAwards(individual);
      setTeamAwards(team);
      setInfluencerAwards(influencer);
      setCommonAwards(common);
      setNominations(nominationsData);
      toast.success('You can now edit your nominations');
    } catch (error) {
      console.error('Error loading nominations for editing:', error);
      toast.error('Failed to load nominations. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Handle view result - for admin panel
  const handleViewResult = () => {
    setViewMode('allNominations');
  };

  // Fetch all nominations (admin only)
  const fetchAllNominations = async (page: number = 1, awardId?: string) => {
    try {
      setAllNominationsLoading(true);
      const { nominations, metadata } = await getAllNominationsAdmin({
        page: 1,
        limit: allNominationsLimit,
        awardId,
      });
      setAllNominations(nominations);
      setAllNominationsPagination(metadata);
    } catch (error) {
      console.error('Error fetching all nominations:', error);
      setAllNominations([]);
    } finally {
      setAllNominationsLoading(false);
    }
  };

  // Fetch all awards
  const fetchAllAwards = async () => {
    try {
      const awards = await getAllAwards();
      setAllAwardsList(awards);
    } catch (error) {
      console.error('Error fetching awards:', error);
      setAllAwardsList([]);
    }
  };

  // Fetch highest app downloads
  const fetchHighestAppDownloads = async (limit: number = 10) => {
    try {
      setLeadingWinnersLoading(true);
      const results = await getHighestAppDownloads(limit);
      setLeadingWinners(results);
    } catch (error) {
      console.error('Error fetching highest app downloads:', error);
      setLeadingWinners([]);
    } finally {
      setLeadingWinnersLoading(false);
    }
  };

  // Fetch highest app downloads by team
  const fetchHighestAppDownloadsByTeam = async (limit: number = 10) => {
    try {
      setTeamAppDownloadsWinnersLoading(true);
      const results = await getHighestAppDownloadsByTeam(limit);
      setTeamAppDownloadsWinners(results);
    } catch (error) {
      console.error('Error fetching highest app downloads by team:', error);
      setTeamAppDownloadsWinners([]);
    } finally {
      setTeamAppDownloadsWinnersLoading(false);
    }
  };

  // Fetch highest approaches by team
  const fetchHighestApproachesByTeam = async (limit: number = 10) => {
    try {
      setTeamApproachesWinnersLoading(true);
      const results = await getHighestApproachesByTeam(limit);
      setTeamApproachesWinners(results);
    } catch (error) {
      console.error('Error fetching highest approaches by team:', error);
      setTeamApproachesWinners([]);
    } finally {
      setTeamApproachesWinnersLoading(false);
    }
  };

  // Fetch highest college referrals by team
  const fetchHighestCollegeReferralsByTeam = async (limit: number = 10) => {
    try {
      setTeamCollegeReferralsWinnersLoading(true);
      const results = await getHighestCollegeReferralsByTeam(limit);
      setTeamCollegeReferralsWinners(results);
    } catch (error) {
      console.error('Error fetching highest college referrals by team:', error);
      setTeamCollegeReferralsWinners([]);
    } finally {
      setTeamCollegeReferralsWinnersLoading(false);
    }
  };

  // Fetch highest company referrals by team
  const fetchHighestCompanyReferralsByTeam = async (limit: number = 10) => {
    try {
      setTeamCompanyReferralsWinnersLoading(true);
      const results = await getHighestCompanyReferralsByTeam(limit);
      setTeamCompanyReferralsWinners(results);
    } catch (error) {
      console.error('Error fetching highest company referrals by team:', error);
      setTeamCompanyReferralsWinners([]);
    } finally {
      setTeamCompanyReferralsWinnersLoading(false);
    }
  };

  // Fetch highest job posts created by team
  const fetchHighestJobPostsCreatedByTeam = async (limit: number = 10) => {
    try {
      setTeamJobPostsWinnersLoading(true);
      const results = await getHighestJobPostsCreatedByTeam(limit);
      setTeamJobPostsWinners(results);
    } catch (error) {
      console.error('Error fetching highest job posts created by team:', error);
      setTeamJobPostsWinners([]);
    } finally {
      setTeamJobPostsWinnersLoading(false);
    }
  };

  // Fetch highest joinings by team
  const fetchHighestJoiningsByTeam = async (limit: number = 10) => {
    try {
      setTeamJoiningsWinnersLoading(true);
      const results = await getHighestJoiningsByTeam(limit);
      setTeamJoiningsWinners(results);
    } catch (error) {
      console.error('Error fetching highest joinings by team:', error);
      setTeamJoiningsWinners([]);
    } finally {
      setTeamJoiningsWinnersLoading(false);
    }
  };

  // Fetch highest selections by team
  const fetchHighestSelectionsByTeam = async (limit: number = 10) => {
    try {
      setTeamSelectionsWinnersLoading(true);
      const results = await getHighestSelectionsByTeam(limit);
      setTeamSelectionsWinners(results);
    } catch (error) {
      console.error('Error fetching highest selections by team:', error);
      setTeamSelectionsWinners([]);
    } finally {
      setTeamSelectionsWinnersLoading(false);
    }
  };

  // Fetch highest interns added by team
  const fetchHighestInternsAddedByTeam = async (limit: number = 10) => {
    try {
      setTeamInternsAddedWinnersLoading(true);
      const results = await getHighestInternsAddedByTeam(limit);
      setTeamInternsAddedWinners(results);
    } catch (error) {
      console.error('Error fetching highest interns added by team:', error);
      setTeamInternsAddedWinners([]);
    } finally {
      setTeamInternsAddedWinnersLoading(false);
    }
  };

  // Fetch highest talent pool creation by team
  const fetchHighestTalentPoolCreationByTeam = async (limit: number = 10) => {
    try {
      setTeamTalentPoolCreationWinnersLoading(true);
      const results = await getHighestTalentPoolCreationByTeam(limit);
      setTeamTalentPoolCreationWinners(results);
    } catch (error) {
      console.error('Error fetching highest talent pool creation by team:', error);
      setTeamTalentPoolCreationWinners([]);
    } finally {
      setTeamTalentPoolCreationWinnersLoading(false);
    }
  };

  // Fetch highest walk-ins by team
  const fetchHighestWalkInsByTeam = async (limit: number = 10) => {
    try {
      setTeamWalkInsWinnersLoading(true);
      const results = await getHighestWalkInsByTeam(limit);
      setTeamWalkInsWinners(results);
    } catch (error) {
      console.error('Error fetching highest walk-ins by team:', error);
      setTeamWalkInsWinners([]);
    } finally {
      setTeamWalkInsWinnersLoading(false);
    }
  };

  // Fetch highest approach award
  const fetchHighestApproachAward = async (limit: number = 10) => {
    try {
      setApproachWinnersLoading(true);
      const results = await getHighestApproachAward(limit);
      setApproachWinners(results);
    } catch (error) {
      console.error('Error fetching highest approach award:', error);
      setApproachWinners([]);
    } finally {
      setApproachWinnersLoading(false);
    }
  };

  // Fetch highest subjob post creation
  const fetchHighestSubjobPostCreation = async (limit: number = 10) => {
    try {
      setSubjobWinnersLoading(true);
      const results = await getHighestSubjobPostCreation(limit);
      setSubjobWinners(results);
    } catch (error) {
      console.error('Error fetching highest subjob post creation:', error);
      setSubjobWinners([]);
    } finally {
      setSubjobWinnersLoading(false);
    }
  };

  // Fetch highest joinings award
  const fetchHighestJoiningsAward = async (limit: number = 10) => {
    try {
      setJoiningsWinnersLoading(true);
      const results = await getHighestJoiningsAward(limit);
      setJoiningsWinners(results);
    } catch (error) {
      console.error('Error fetching highest joinings award:', error);
      setJoiningsWinners([]);
    } finally {
      setJoiningsWinnersLoading(false);
    }
  };

  // Fetch highest selections award
  const fetchHighestSelectionsAward = async (limit: number = 10) => {
    try {
      setSelectionsWinnersLoading(true);
      const results = await getHighestSelectionsAward(limit);
      setSelectionsWinners(results);
    } catch (error) {
      console.error('Error fetching highest selections award:', error);
      setSelectionsWinners([]);
    } finally {
      setSelectionsWinnersLoading(false);
    }
  };

  // Fetch highest walk-ins award
  const fetchHighestWalkInsAward = async (limit: number = 10) => {
    try {
      setWalkInsWinnersLoading(true);
      const results = await getHighestWalkInsAward(limit);
      setWalkInsWinners(results);
    } catch (error) {
      console.error('Error fetching highest walk-ins award:', error);
      setWalkInsWinners([]);
    } finally {
      setWalkInsWinnersLoading(false);
    }
  };

  // Fetch highest talent pool creation award
  const fetchHighestTalentPoolCreationAward = async (limit: number = 10) => {
    try {
      setTalentPoolWinnersLoading(true);
      const results = await getHighestTalentPoolCreationAward(limit);
      setTalentPoolWinners(results);
    } catch (error) {
      console.error('Error fetching highest talent pool creation award:', error);
      setTalentPoolWinners([]);
    } finally {
      setTalentPoolWinnersLoading(false);
    }
  };

  // Fetch highest college referral award
  const fetchHighestCollegeReferralAward = async (limit: number = 10) => {
    try {
      setCollegeReferralWinnersLoading(true);
      const results = await getHighestCollegeReferralAward(limit);
      setCollegeReferralWinners(results);
    } catch (error) {
      console.error('Error fetching highest college referral award:', error);
      setCollegeReferralWinners([]);
    } finally {
      setCollegeReferralWinnersLoading(false);
    }
  };

  // Fetch highest company referral award
  const fetchHighestCompanyReferralAward = async (limit: number = 10) => {
    try {
      setCompanyReferralWinnersLoading(true);
      const results = await getHighestCompanyReferralAward(limit);
      setCompanyReferralWinners(results);
    } catch (error) {
      console.error('Error fetching highest company referral award:', error);
      setCompanyReferralWinners([]);
    } finally {
      setCompanyReferralWinnersLoading(false);
    }
  };

  // Fetch registered users with nominations
  const fetchRegisteredUsers = async (page: number = 1, search?: string) => {
    try {
      setRegisteredUsersLoading(true);
      const { users, metadata } = await getRegisteredUsersWithNominations({
        page,
        limit: registeredUsersLimit,
        search,
      });
      setRegisteredUsers(users);
      setRegisteredUsersPagination(metadata);
    } catch (error) {
      console.error('Error fetching registered users:', error);
      setRegisteredUsers([]);
    } finally {
      setRegisteredUsersLoading(false);
    }
  };

  // Export registered users to Excel
  const handleExportRegisteredUsersToExcel = async () => {
    try {
      toast.loading('Exporting data to Excel...', { id: 'export-excel' });

      let allUsers: IRegisteredUserWithNominations[] = [];
      let currentPage = 1;
      let totalPages = 1;
      const pageLimit = 100; // Fetch more records per page for export

      // Fetch all pages of data
      do {
        const { users, metadata } = await getRegisteredUsersWithNominations({
          page: currentPage,
          limit: pageLimit,
          search: registeredUsersSearch,
        });
        
        allUsers = [...allUsers, ...users];
        totalPages = metadata.totalPages;
        currentPage++;
      } while (currentPage <= totalPages);

      if (allUsers.length === 0) {
        toast.error('No data to export', { id: 'export-excel' });
        return;
      }

      // Find the maximum number of nominations to determine how many columns we need
      const maxNominations = Math.max(...allUsers.map(user => user.nominationNames?.length || 0), 0);

      // Map data to Excel format with dynamic nomination columns
      const excelData = allUsers.map((user, index) => {
        const baseData: any = {
          'S.No': index + 1,
          'Name': user.username || '',
          'Email': user.email || '',
          'Phone': user.phone || 'N/A',
          'Role': user.role || '',
          'Nominations Count': user.nominationCount || 0,
          'Registered Date': user.createdAt ? format(new Date(user.createdAt), 'yyyy-MM-dd') : 'N/A',
        };

        // Add nomination columns dynamically
        for (let i = 0; i < maxNominations; i++) {
          const nominationName = user.nominationNames && user.nominationNames[i] 
            ? user.nominationNames[i] 
            : '';
          baseData[`Nomination ${i + 1}`] = nominationName;
        }

        return baseData;
      });

      // Create worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Registered Users');

      // Generate Excel file and trigger download
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `registered_users_${format(new Date(), 'yyyy-MM-dd')}.xlsx`);
      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success('Excel file downloaded successfully!', { id: 'export-excel' });
    } catch (error: any) {
      console.error('Failed to export Excel:', error);
      toast.error(
        `Failed to export: ${error?.response?.data?.message || error?.message || 'Unknown error'}`,
        { id: 'export-excel' }
      );
    }
  };

  // Fetch unregistered active users
  const fetchUnregisteredUsers = async (page: number = 1, search?: string) => {
    try {
      setUnregisteredUsersLoading(true);
      const { users, metadata } = await getUnregisteredActiveUsers({
        page,
        limit: unregisteredUsersLimit,
        search,
      });
      setUnregisteredUsers(users);
      setUnregisteredUsersPagination(metadata);
    } catch (error) {
      console.error('Error fetching unregistered users:', error);
      setUnregisteredUsers([]);
    } finally {
      setUnregisteredUsersLoading(false);
    }
  };

  // Export unregistered users to Excel
  const handleExportUnregisteredUsersToExcel = async () => {
    try {
      toast.loading('Exporting data to Excel...', { id: 'export-excel' });

      let allUsers: IRegisteredUserWithNominations[] = [];
      let currentPage = 1;
      let totalPages = 1;
      const pageLimit = 100; // Fetch more records per page for export

      // Fetch all pages of data
      do {
        const { users, metadata } = await getUnregisteredActiveUsers({
          page: currentPage,
          limit: pageLimit,
          search: unregisteredUsersSearch,
        });
        
        allUsers = [...allUsers, ...users];
        totalPages = metadata.totalPages;
        currentPage++;
      } while (currentPage <= totalPages);

      if (allUsers.length === 0) {
        toast.error('No data to export', { id: 'export-excel' });
        return;
      }

      // Map data to Excel format
      const excelData = allUsers.map((user, index) => ({
        'S.No': index + 1,
        'Name': user.username || '',
        'Email': user.email || '',
        'Phone': user.phone || 'N/A',
        'Role': user.role || '',
        'Nominations Count': user.nominationCount || 0,
        'Registered Date': user.createdAt ? format(new Date(user.createdAt), 'yyyy-MM-dd') : 'N/A',
      }));

      // Create worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Unregistered Users');

      // Generate Excel file and trigger download
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `unregistered_users_${format(new Date(), 'yyyy-MM-dd')}.xlsx`);
      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success('Excel file downloaded successfully!', { id: 'export-excel' });
    } catch (error: any) {
      console.error('Failed to export Excel:', error);
      toast.error(
        `Failed to export: ${error?.response?.data?.message || error?.message || 'Unknown error'}`,
        { id: 'export-excel' }
      );
    }
  };

  // Fetch all nominations and awards when view mode changes
  useEffect(() => {
    if (viewMode === 'allNominations') {
      setAllNominationsPage(1);
      setSelectedAwardId(undefined);
      fetchAllAwards();
      fetchAllNominations(1);
    } else if (viewMode === 'viewResult') {
      setSelectedAwardId(undefined);
      fetchAllAwards();
      fetchHighestAppDownloads(10);
    } else if (viewMode === 'registeredUsers') {
      setRegisteredUsersPage(1);
      setRegisteredUsersSearch('');
      fetchRegisteredUsers(1);
    } else if (viewMode === 'unregisteredUsers') {
      setUnregisteredUsersPage(1);
      setUnregisteredUsersSearch('');
      fetchUnregisteredUsers(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewMode]);

  // Fetch nominations when award filter changes
  useEffect(() => {
    if (viewMode === 'allNominations') {
      fetchAllNominations(1, selectedAwardId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAwardId]);

  // Fetch winners when specific award is selected in view result
  useEffect(() => {
    if (viewMode === 'viewResult' && selectedAwardId) {
      const selectedAward = allAwardsList.find(award => award._id === selectedAwardId);
      if (selectedAward) {
        const awardName = selectedAward.name;
        if (awardName.toLowerCase().includes('approach')) {
          fetchHighestApproachAward(10);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
        } else if (awardName === 'Highest Job Posts Created Award') {
          fetchHighestSubjobPostCreation(10);
          setApproachWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
        } else if (awardName === 'Highest Joinings Award') {
          fetchHighestJoiningsAward(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setSelectionsWinners([]);
        } else if (awardName === 'Highest Selections Award') {
          fetchHighestSelectionsAward(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setWalkInsWinners([]);
        } else if (awardName === 'Highest Walk-ins Award') {
          fetchHighestWalkInsAward(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setTalentPoolWinners([]);
        } else if (awardName === 'Highest Talent Pool Creation Award') {
          fetchHighestTalentPoolCreationAward(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
        } else if (awardName === 'Highest College Referral Award') {
          fetchHighestCollegeReferralAward(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCompanyReferralWinners([]);
        } else if (awardName === 'Highest Company Referral Award') {
          fetchHighestCompanyReferralAward(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
        } else if (awardName === 'Highest App Download Invitations by Team Award') {
          fetchHighestAppDownloadsByTeam(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
          setLeadingWinners([]);
          setTeamApproachesWinners([]);
        } else if (awardName === 'Highest Approaches by Team Award') {
          fetchHighestApproachesByTeam(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
          setLeadingWinners([]);
          setTeamAppDownloadsWinners([]);
          setTeamCollegeReferralsWinners([]);
        } else if (awardName === 'Highest College Referral by Team Award') {
          fetchHighestCollegeReferralsByTeam(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
          setLeadingWinners([]);
          setTeamAppDownloadsWinners([]);
          setTeamApproachesWinners([]);
          setTeamCompanyReferralsWinners([]);
        } else if (awardName === 'Highest Company Referral by Team Award') {
          fetchHighestCompanyReferralsByTeam(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
          setLeadingWinners([]);
          setTeamAppDownloadsWinners([]);
          setTeamApproachesWinners([]);
          setTeamCollegeReferralsWinners([]);
          setTeamJobPostsWinners([]);
        } else if (awardName === 'Highest Job Posts Created by Team Award') {
          fetchHighestJobPostsCreatedByTeam(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
          setLeadingWinners([]);
          setTeamAppDownloadsWinners([]);
          setTeamApproachesWinners([]);
          setTeamCollegeReferralsWinners([]);
          setTeamCompanyReferralsWinners([]);
          setTeamJoiningsWinners([]);
        } else if (awardName === 'Highest Joinings by Team Award') {
          fetchHighestJoiningsByTeam(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
          setLeadingWinners([]);
          setTeamAppDownloadsWinners([]);
          setTeamApproachesWinners([]);
          setTeamCollegeReferralsWinners([]);
          setTeamCompanyReferralsWinners([]);
          setTeamJobPostsWinners([]);
          setTeamSelectionsWinners([]);
        } else if (awardName === 'Highest Selections by Team Award') {
          fetchHighestSelectionsByTeam(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
          setLeadingWinners([]);
          setTeamAppDownloadsWinners([]);
          setTeamApproachesWinners([]);
          setTeamCollegeReferralsWinners([]);
          setTeamCompanyReferralsWinners([]);
          setTeamJobPostsWinners([]);
          setTeamJoiningsWinners([]);
          setTeamInternsAddedWinners([]);
        } else if (awardName === 'Highest Number of Interns Added Award') {
          fetchHighestInternsAddedByTeam(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
          setLeadingWinners([]);
          setTeamAppDownloadsWinners([]);
          setTeamApproachesWinners([]);
          setTeamCollegeReferralsWinners([]);
          setTeamCompanyReferralsWinners([]);
          setTeamJobPostsWinners([]);
          setTeamJoiningsWinners([]);
          setTeamSelectionsWinners([]);
          setTeamTalentPoolCreationWinners([]);
        } else if (awardName === 'Highest Talent Pool Creation by Team Award') {
          fetchHighestTalentPoolCreationByTeam(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
          setLeadingWinners([]);
          setTeamAppDownloadsWinners([]);
          setTeamApproachesWinners([]);
          setTeamCollegeReferralsWinners([]);
          setTeamCompanyReferralsWinners([]);
          setTeamJobPostsWinners([]);
          setTeamJoiningsWinners([]);
          setTeamSelectionsWinners([]);
          setTeamInternsAddedWinners([]);
          setTeamWalkInsWinners([]);
        } else if (awardName === 'Highest Walk-ins by Team Award') {
          fetchHighestWalkInsByTeam(10);
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
          setLeadingWinners([]);
          setTeamAppDownloadsWinners([]);
          setTeamApproachesWinners([]);
          setTeamCollegeReferralsWinners([]);
          setTeamCompanyReferralsWinners([]);
          setTeamJobPostsWinners([]);
          setTeamJoiningsWinners([]);
          setTeamSelectionsWinners([]);
          setTeamInternsAddedWinners([]);
          setTeamTalentPoolCreationWinners([]);
        } else {
          // Reset all if not a specific award type
          setApproachWinners([]);
          setSubjobWinners([]);
          setJoiningsWinners([]);
          setSelectionsWinners([]);
          setWalkInsWinners([]);
          setTalentPoolWinners([]);
          setCollegeReferralWinners([]);
          setCompanyReferralWinners([]);
          setTeamAppDownloadsWinners([]);
        }
      }
    } else if (viewMode === 'viewResult' && !selectedAwardId) {
      // Reset when "All Awards" is selected
      setApproachWinners([]);
      setSubjobWinners([]);
      setJoiningsWinners([]);
      setSelectionsWinners([]);
      setWalkInsWinners([]);
      setTalentPoolWinners([]);
      setCollegeReferralWinners([]);
      setCompanyReferralWinners([]);
      setTeamAppDownloadsWinners([]);
      setTeamApproachesWinners([]);
      setTeamCollegeReferralsWinners([]);
      setTeamCompanyReferralsWinners([]);
      setTeamJobPostsWinners([]);
      setTeamJoiningsWinners([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAwardId, viewMode, allAwardsList]);

  // Handle award filter change
  const handleAwardFilterChange = (awardId: string | undefined) => {
    setSelectedAwardId(awardId);
    setAllNominationsSearch(''); // Clear search when changing award filter
  };

  // Render submitted nominations screen if user has already submitted
  const renderSubmittedNominations = () => {
    // Group nominations by category
    const individualNoms: INomination[] = [];
    const teamNoms: INomination[] = [];
    const influencerNoms: INomination[] = [];
    const commonNoms: INomination[] = [];

    submittedNominations.forEach((nom: INomination) => {
      const award = typeof nom.awardId === 'string' ? null : nom.awardId;
      if (!award) return;

      switch (award.category) {
        case 'Individual Winner':
          individualNoms.push(nom);
          break;
        case 'Team Winner':
          teamNoms.push(nom);
          break;
        case 'Influencer Award':
          influencerNoms.push(nom);
          break;
        case 'Common Award':
          commonNoms.push(nom);
          break;
      }
    });

    // Check if user has permission to view team nominations
    const canViewTeamNominations = user?.role === 'ADMIN' || user?.role === 'SHM' || user?.role === 'FBDE' || user?.role === 'HM' || user?.role === 'AGENCY';

    return (
      <>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-orange-50/40 p-4 sm:p-6">
        <div className="max-w-7xl mx-auto space-y-4">
          {/* Header with Team Nominations Button and Edit Nomination */}
          <div className="flex justify-between items-center mb-4">
            <div className="flex gap-3">
            <Button
              variant="outline"
              className="bg-white hover:bg-gray-50 border-gray-300 text-gray-700"
              onClick={handleEditNomination}
            >
              <Edit className="h-4 w-4 mr-2" />
              Edit Nomination
            </Button>
            <Button
              variant="outline"
              className="bg-white hover:bg-gray-50 border-gray-300 text-gray-700"
              onClick={() => setViewMode('viewResult')}
            >
              <Trophy className="h-4 w-4 mr-2" />
              View Result
            </Button>
              {user?.role === 'ADMIN' && (
                <>
                  <Button
                    variant="outline"
                    className="bg-white hover:bg-gray-50 border-gray-300 text-gray-700"
                    onClick={handleViewResult}
                  >
                    <Eye className="h-4 w-4 mr-2" />
                    Total nominations
                  </Button>
                  <Button
                    variant="outline"
                    className="bg-white hover:bg-gray-50 border-gray-300 text-gray-700"
                    onClick={() => setViewMode('registeredUsers')}
                  >
                    <UserCheck className="h-4 w-4 mr-2" />
                    Registered users
                  </Button>
                  <Button
                    variant="outline"
                    className="bg-white hover:bg-gray-50 border-gray-300 text-gray-700"
                    onClick={() => setViewMode('unregisteredUsers')}
                  >
                    <UserX className="h-4 w-4 mr-2" />
                    Not registered users
                  </Button>
                </>
              )}
            </div>
            {canViewTeamNominations && (
              <Button
                variant="outline"
                className="bg-white hover:bg-gray-50 border-gray-300 text-gray-700"
                onClick={() => setViewMode('teamNominations')}
              >
                <Users className="h-4 w-4 mr-2" />
                My Team Nominations
              </Button>
            )}
          </div>

          {/* App Promotion Section */}
          <Card className="shadow-lg border-2 border-gray-200">
            <CardHeader className="bg-white border-b border-gray-200 rounded-t-lg">
              <CardTitle className="flex items-center gap-2 text-lg sm:text-xl text-gray-900">
                <MessageCircle className="h-5 w-5" />
                📱 Promote EarlyJobs App
              </CardTitle>
            </CardHeader>
            <CardContent className="p-4 sm:p-6">
              {/* App Link Display */}
              <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
                <h3 className="text-sm font-semibold text-gray-800 mb-2">App Download Link</h3>
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    value={appLink}
                    readOnly
                    className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-md bg-white"
                  />
                  <Button
                    onClick={() => {
                      navigator.clipboard.writeText(appLink);
                      toast.success('App link copied to clipboard!');
                    }}
                    size="sm"
                    className="bg-blue-600 hover:bg-blue-700 text-white"
                  >
                    <Copy className="h-4 w-4 mr-1" />
                    Copy
                  </Button>
                  <Button
                    onClick={() => window.open(appLink, '_blank')}
                    size="sm"
                    variant="outline"
                    className="border-blue-600 text-blue-600 hover:bg-blue-50"
                  >
                    <ExternalLink className="h-4 w-4" />
                  </Button>
                </div>
              </div>

              {/* WhatsApp Promotion Section */}
              <div className="space-y-4">
                <div>
                  <h3 className="text-sm font-semibold text-gray-800 mb-2 flex items-center gap-2">
                    <MessageCircle className="h-4 w-4 text-green-600" />
                    Send App Promotion via WhatsApp
                  </h3>
                  <p className="text-xs text-gray-600 mb-3">
                    Enter WhatsApp numbers (comma-separated or one per line) to send the app promotion message
                  </p>
                  
                  <textarea
                    value={whatsappNumbers}
                    onChange={(e) => {
                      if (e.target.value.length <= 2500) {
                        setWhatsappNumbers(e.target.value);
                      }
                    }}
                    placeholder="Enter WhatsApp numbers (e.g., 919876543210, 919123456789 or one per line)"
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#EC6E51] resize-none"
                    rows={4}
                    maxLength={2500}
                  />
                  
                  <div className="mt-2 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <p className="text-xs text-gray-500">
                        {whatsappNumbers.split(/[,\n]/).filter(num => num.trim()).length} number(s) entered
                      </p>
                      <p className={`text-xs ${whatsappNumbers.length >= 2500 ? 'text-red-600 font-semibold' : 'text-gray-500'}`}>
                        {whatsappNumbers.length} / 2500 characters
                      </p>
                    </div>
                    <Button
                      onClick={async () => {
                        const numbers = whatsappNumbers.split(/[,\n]/).filter(num => num.trim());
                        if (numbers.length === 0) {
                          toast.error('Please enter at least one WhatsApp number');
                          return;
                        }

                        try {
                          setSendingWhatsApp(true);
                          const result = await sendAppPromotionWhatsApp(numbers, appLink);
                          
                          if (result.success > 0) {
                            toast.success(`Successfully sent ${result.success} message(s) via WhatsApp!`);
                            setWhatsappNumbers(''); // Clear the input after successful send
                            // Refresh referral data after sending
                            await fetchReferralData();
                          }
                          
                          if (result.failed > 0) {
                            toast.error(`Failed to send ${result.failed} message(s). Please check the numbers and try again.`);
                          }
                        } catch (error: any) {
                          console.error('Error sending WhatsApp messages:', error);
                          // Error toast is already shown by the API function
                        } finally {
                          setSendingWhatsApp(false);
                        }
                      }}
                      disabled={sendingWhatsApp}
                      className="bg-green-600 hover:bg-green-700 text-white disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {sendingWhatsApp ? (
                        <>
                          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                          Sending...
                        </>
                      ) : (
                        <>
                          <Send className="h-4 w-4 mr-2" />
                          Send via WhatsApp
                        </>
                      )}
                    </Button>
                  </div>
                </div>

                {/* Preview Message */}
                <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                  <div className="flex items-center justify-between mb-2">
                    <p className="text-xs font-semibold text-gray-700">Preview Message:</p>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => {
                        const message = `Hello 

I'm ${user?.username } from EarlyJobs.
We have verified job openings near your location that match your profile.

Local jobs
Faster interview calls
Easy apply from mobile

Download the EarlyJobs App & apply now: ${appLink}

Apply today and don't miss nearby opportunities`;
                        navigator.clipboard.writeText(message);
                        toast.success('Message copied to clipboard!');
                      }}
                      className="h-7 text-xs"
                    >
                      <Copy className="h-3 w-3 mr-1" />
                      Copy
                    </Button>
                  </div>
                  <p className="text-xs text-gray-600 whitespace-pre-wrap">
                    {`Hello 

I'm ${user?.username } from EarlyJobs.
We have verified job openings near your location that match your profile.

Local jobs
Faster interview calls
Easy apply from mobile

Download the EarlyJobs App & apply now: ${appLink}

Apply today and don't miss nearby opportunities`}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Successful Referrals Section */}
          <Card className="shadow-lg border-2 border-gray-200">
            <CardHeader className="bg-white border-b border-gray-200 rounded-t-lg">
              <CardTitle className="flex items-center gap-2 text-lg sm:text-xl text-gray-900">
                <TrendingUp className="h-5 w-5" />
                🎉 Successful Referrals
              </CardTitle>
            </CardHeader>
            <CardContent className="p-4 sm:p-6">
              {loadingReferrals ? (
                <div className="text-center py-8">
                  <Loader2 className="h-8 w-8 animate-spin text-[#EC6E51] mx-auto mb-4" />
                  <p className="text-sm text-gray-600">Loading referrals...</p>
                </div>
              ) : successfulReferrals.length === 0 ? (
                <div className="text-center py-8">
                  <UserCheck className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                  <p className="text-sm text-gray-600">No successful referrals yet.</p>
                  <p className="text-xs text-gray-500 mt-1">Start sharing your app link to see referrals here!</p>
                </div>
              ) : (
                <div className="space-y-3">
                  <div className="flex items-center justify-between mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                    <div>
                      <p className="text-xs text-gray-600">Total Successful Referrals</p>
                      <p className="text-2xl font-bold text-[#EC6E51]">{referralStats?.totalSent || successfulReferrals.length}</p>
                      {referralStats && (
                        <p className="text-xs text-gray-500 mt-1">
                          {referralStats.accountCreated} account(s) created
                        </p>
                      )}
                    </div>
                    <TrendingUp className="h-8 w-8 text-green-500" />
                  </div>
                  
                  <div className="space-y-2">
                    {successfulReferrals.map((referral, index) => (
                      <div
                        key={referral._id}
                        className="flex items-center justify-between p-3 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border border-green-200 hover:shadow-md transition-shadow"
                      >
                        <div className="flex items-center space-x-3 flex-1">
                          <div className="flex-shrink-0 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                            {index + 1}
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-sm font-semibold text-gray-800 truncate">
                              {referral.referralName || `+91 ${referral.phoneNumber}`}
                            </p>
                            <div className="flex items-center gap-3 mt-1 flex-wrap">
                              <p className="text-xs text-gray-600">+91 {referral.phoneNumber}</p>
                              <span className="text-xs text-gray-500">•</span>
                              <p className="text-xs text-gray-600">
                                Referred on {new Date(referral.sentAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="flex-shrink-0 ml-3 flex flex-col gap-2 items-end">
                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                            referral.status === 'sent' || referral.status === 'delivered'
                              ? 'bg-green-100 text-green-800'
                              : 'bg-red-100 text-red-800'
                          }`}>
                            {referral.status === 'sent' ? 'Sent' : referral.status === 'delivered' ? 'Delivered' : 'Failed'}
                          </span>
                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                            referral.accountCreated 
                              ? 'bg-blue-100 text-blue-800' 
                              : 'bg-yellow-100 text-yellow-800'
                          }`}>
                            {referral.accountCreated ? '✓ Account Created' : '⏳ Pending'}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Pagination */}
                  {referralPagination && referralPagination.totalPages > 1 && (
                    <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-200">
                      <div className="text-xs text-gray-600">
                        Showing {((referralPagination.page - 1) * referralPagination.limit) + 1} to{' '}
                        {Math.min(referralPagination.page * referralPagination.limit, referralPagination.totalResults)} of{' '}
                        {referralPagination.totalResults} referrals
                      </div>
                      <div className="flex items-center gap-2">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => handleReferralPageChange(referralPage - 1)}
                          disabled={referralPage === 1 || loadingReferrals}
                          className="h-8"
                        >
                          <ChevronLeft className="h-4 w-4" />
                        </Button>
                        
                        {Array.from({ length: Math.min(5, referralPagination.totalPages) }, (_, i) => {
                          let pageNum: number;
                          if (referralPagination.totalPages <= 5) {
                            pageNum = i + 1;
                          } else if (referralPage <= 3) {
                            pageNum = i + 1;
                          } else if (referralPage >= referralPagination.totalPages - 2) {
                            pageNum = referralPagination.totalPages - 4 + i;
                          } else {
                            pageNum = referralPage - 2 + i;
                          }
                          
                          return (
                            <Button
                              key={pageNum}
                              variant={referralPage === pageNum ? "default" : "outline"}
                              size="sm"
                              onClick={() => handleReferralPageChange(pageNum)}
                              disabled={loadingReferrals}
                              className={`h-8 ${
                                referralPage === pageNum
                                  ? 'bg-[#EC6E51] text-white hover:bg-[#E66A4E]'
                                  : ''
                              }`}
                            >
                              {pageNum}
                            </Button>
                          );
                        })}

                        {referralPagination.totalPages > 5 && referralPage < referralPagination.totalPages - 2 && (
                          <>
                            <span className="text-xs text-gray-500">...</span>
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => handleReferralPageChange(referralPagination.totalPages)}
                              disabled={loadingReferrals}
                              className="h-8"
                            >
                              {referralPagination.totalPages}
                            </Button>
                          </>
                        )}

                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => handleReferralPageChange(referralPage + 1)}
                          disabled={referralPage === referralPagination.totalPages || loadingReferrals}
                          className="h-8"
                        >
                          <ChevronRight className="h-4 w-4" />
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </CardContent>
          </Card>

          {/* Individual Winner Categories - Compact */}
          {individualNoms.length > 0 && (
            <Card className="shadow-md border border-gray-200">
              <CardHeader className="bg-gradient-to-r from-[#EC6E51] to-[#E66A4E] text-white rounded-t-lg py-2">
                <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
                  <Trophy className="h-4 w-4" />
                  Individual Winner Categories
                </CardTitle>
              </CardHeader>
              <CardContent className="p-2 sm:p-3">
                <div className="space-y-1.5">
                  {individualNoms.map((nom, index) => {
                    const award = typeof nom.awardId === 'string' ? null : nom.awardId;
                    return award ? (
                      <div
                        key={nom._id}
                        className="flex items-center space-x-2 p-1.5 rounded bg-green-50 border border-green-200"
                      >
                        <CheckCircle2 className="h-3.5 w-3.5 text-green-500 flex-shrink-0" />
                        <span className="text-xs text-gray-600 font-semibold mr-1">{index + 1}.</span>
                        <span className="flex-1 text-xs sm:text-sm font-medium text-gray-700">
                          {award.name}
                        </span>
                      </div>
                    ) : null;
                  })}
                </div>
              </CardContent>
            </Card>
          )}

          {/* Team Winner Categories - Compact (Hidden for HR) */}
          {teamNoms.length > 0 && user?.role !== 'HR' && (
            <Card className="shadow-md border border-gray-200">
              <CardHeader className="bg-gradient-to-r from-[#EC6E51] to-[#E66A4E] text-white rounded-t-lg py-2">
                <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
                  <Users className="h-4 w-4" />
                  🤝 Team Winner Categories
                </CardTitle>
              </CardHeader>
              <CardContent className="p-2 sm:p-3">
                <div className="space-y-1.5">
                  {teamNoms.map((nom, index) => {
                    const award = typeof nom.awardId === 'string' ? null : nom.awardId;
                    return award ? (
                      <div
                        key={nom._id}
                        className="flex items-center space-x-2 p-1.5 rounded bg-green-50 border border-green-200"
                      >
                        <CheckCircle2 className="h-3.5 w-3.5 text-green-500 flex-shrink-0" />
                        <span className="text-xs text-gray-600 font-semibold mr-1">{index + 1}.</span>
                        <span className="flex-1 text-xs sm:text-sm font-medium text-gray-700">
                          {award.name}
                        </span>
                      </div>
                    ) : null;
                  })}
                </div>
              </CardContent>
            </Card>
          )}

          {/* Influencer Award Categories - Compact */}
          {influencerNoms.length > 0 && (
            <Card className="shadow-md border border-gray-200">
              <CardHeader className="bg-gradient-to-r from-[#EC6E51] to-[#E66A4E] text-white rounded-t-lg py-2">
                <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
                  <Star className="h-4 w-4" />
                  🌟 Influencer Award Categories
                </CardTitle>
              </CardHeader>
              <CardContent className="p-2 sm:p-3">
                <div className="space-y-1.5">
                  {influencerNoms.map((nom, index) => {
                    const award = typeof nom.awardId === 'string' ? null : nom.awardId;
                    return award ? (
                      <div
                        key={nom._id}
                        className="p-1.5 rounded bg-green-50 border border-green-200"
                      >
                        <div className="flex items-start space-x-2">
                          <CheckCircle2 className="h-3.5 w-3.5 text-green-500 mt-0.5 flex-shrink-0" />
                          <div className="flex-1">
                            <div className="flex items-center">
                              <span className="text-xs text-gray-600 font-semibold mr-1">{index + 1}.</span>
                              <span className="text-xs sm:text-sm font-medium text-gray-700">
                                {award.name}
                              </span>
                            </div>
                            {award.description && (
                              <p className="text-xs text-gray-500 mt-0.5 ml-4">
                                ({award.description})
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : null;
                  })}
                </div>
              </CardContent>
            </Card>
          )}

          {/* Common Awards - Compact */}
          {commonNoms.length > 0 && (
            <Card className="shadow-md border border-gray-200">
              <CardHeader className="bg-gradient-to-r from-[#EC6E51] to-[#E66A4E] text-white rounded-t-lg py-2">
                <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
                  <Award className="h-4 w-4" />
                  🌟 Common Awards (For All Categories)
                </CardTitle>
              </CardHeader>
              <CardContent className="p-2 sm:p-3">
                <div className="space-y-1.5">
                  {commonNoms.map((nom, index) => {
                    const award = typeof nom.awardId === 'string' ? null : nom.awardId;
                    // Show "In-house Performer Award" only to INTERNAL_TEAM role
                    if (award && award.name === 'In-house Performer Award' && user?.role !== 'INTERNAL_TEAM') {
                      return null;
                    }
                    return award ? (
                      <div
                        key={nom._id}
                        className="flex items-center space-x-2 p-1.5 rounded bg-green-50 border border-green-200"
                      >
                        <CheckCircle2 className="h-3.5 w-3.5 text-green-500 flex-shrink-0" />
                        <span className="text-xs text-gray-600 font-semibold mr-1">{index + 1}.</span>
                        <span className="flex-1 text-xs sm:text-sm font-medium text-gray-700">
                          {award.name}
                        </span>
                      </div>
                    ) : null;
                  })}
                </div>
              </CardContent>
            </Card>
          )}

        </div>
      </div>
      </>
    );
  };

  // Render All Nominations Screen (Admin only)
  const renderAllNominationsScreen = () => {
    // Filter nominations based on search
    const filteredNominations = allNominations.filter((nomination) => {
      if (!allNominationsSearch.trim()) return true;
      const search = allNominationsSearch.toLowerCase();
      const userId = typeof nomination.userId === 'object' ? nomination.userId : null;
      const award = typeof nomination.awardId === 'object' ? nomination.awardId : null;
      
      const username = userId?.username?.toLowerCase() || '';
      const email = userId?.email?.toLowerCase() || '';
      const phone = userId?.phone?.toLowerCase() || '';
      const role = userId?.role?.toLowerCase() || '';
      const awardName = award?.name?.toLowerCase() || '';
      const awardCategory = award?.category?.toLowerCase() || '';
      
      return username.includes(search) || 
             email.includes(search) || 
             phone.includes(search) ||
             role.includes(search) || 
             awardName.includes(search) || 
             awardCategory.includes(search);
    });

    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-orange-50/40 p-4 sm:p-6">
        <div className="max-w-7xl mx-auto space-y-6">
          {/* Header with Back Button */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="outline"
                onClick={() => setViewMode('main')}
                className="bg-white hover:bg-gray-50 border-gray-300"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back
              </Button>
              <div className="flex items-center gap-3">
                <Eye className="h-6 w-6 text-[#EC6E51]" />
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                  All Nominations
                </h1>
              </div>
            </div>
          </div>

          {/* Main Content: Awards List (Left) and Nominations (Right) */}
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
            {/* Awards List - Left Side */}
            <div className="lg:col-span-1">
              <Card className="border border-gray-200 shadow-sm sticky top-6">
                <CardHeader className="bg-gradient-to-r from-[#EC6E51] to-[#E66A4E] text-white rounded-t-lg py-3">
                  <CardTitle className="flex items-center gap-2 text-base">
                    <Award className="h-5 w-5" />
                    Awards ({allAwardsList.length})
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4 max-h-[calc(100vh-200px)] overflow-y-auto">
                  <div className="space-y-2">
                    <Button
                      variant={selectedAwardId === undefined ? "default" : "outline"}
                      className={`w-full justify-start ${
                        selectedAwardId === undefined 
                          ? 'bg-[#EC6E51] hover:bg-[#E66A4E] text-white' 
                          : 'bg-white hover:bg-gray-50'
                      }`}
                      onClick={() => handleAwardFilterChange(undefined)}
                    >
                      All Awards
                    </Button>
                    {allAwardsList.map((award) => (
                      <Button
                        key={award._id}
                        variant={selectedAwardId === award._id ? "default" : "outline"}
                        className={`w-full justify-start text-left ${
                          selectedAwardId === award._id 
                            ? 'bg-[#EC6E51] hover:bg-[#E66A4E] text-white' 
                            : 'bg-white hover:bg-gray-50'
                        }`}
                        onClick={() => handleAwardFilterChange(award._id)}
                      >
                        <div className="flex flex-col items-start w-full">
                          <span className="text-sm font-medium truncate w-full">{award.name}</span>
                          <span className="text-xs opacity-75 mt-0.5">{award.category}</span>
                        </div>
                      </Button>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Nominations List - Right Side */}
            <div className="lg:col-span-3 space-y-6">
              {/* Search Bar */}
              <Card className="border border-gray-200 shadow-sm">
                <CardContent className="p-4">
                  <input
                    type="text"
                    placeholder="Search by user name, email, phone, role, award name, or category..."
                    value={allNominationsSearch}
                    onChange={(e) => {
                      setAllNominationsSearch(e.target.value);
                    }}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#EC6E51] focus:border-transparent"
                  />
                </CardContent>
              </Card>

              {/* Summary Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Card className="border border-gray-200 shadow-sm">
                  <CardContent className="p-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-gray-600 mb-1">Total Nominations</p>
                        <p className="text-3xl font-bold text-gray-900">
                          {allNominationsPagination?.totalResults || 0}
                        </p>
                      </div>
                      <Award className="h-10 w-10 text-[#EC6E51] opacity-20" />
                    </div>
                  </CardContent>
                </Card>
                <Card className="border border-gray-200 shadow-sm">
                  <CardContent className="p-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-gray-600 mb-1">Showing Results</p>
                        <p className="text-3xl font-bold text-gray-900">
                          {filteredNominations.length} / {allNominationsLimit}
                        </p>
                      </div>
                      <Trophy className="h-10 w-10 text-[#EC6E51] opacity-20" />
                    </div>
                  </CardContent>
                </Card>
              </div>

              {/* Loading State */}
              {allNominationsLoading ? (
                <Card className="border border-gray-200 shadow-sm">
                  <CardContent className="p-12 text-center">
                    <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                    <p className="text-lg font-semibold text-gray-600">Loading nominations...</p>
                  </CardContent>
                </Card>
              ) : (
                <>
                  {/* Nominations List */}
                  <div className="space-y-4">
                    {filteredNominations.length === 0 ? (
                      <Card className="border border-gray-200 shadow-sm">
                        <CardContent className="p-12 text-center">
                          <Award className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                          <p className="text-lg font-semibold text-gray-600 mb-2">No nominations found</p>
                          <p className="text-sm text-gray-500">
                            {allNominationsSearch || selectedAwardId
                              ? 'Try adjusting your search criteria or select a different award.'
                              : 'No nominations have been submitted yet.'}
                          </p>
                        </CardContent>
                      </Card>
                    ) : (
                      filteredNominations.slice(0, allNominationsLimit).map((nomination) => {
                        const userId = typeof nomination.userId === 'object' ? nomination.userId : null;
                        const award = typeof nomination.awardId === 'object' ? nomination.awardId : null;
                        
                        if (!userId || !award) return null;

                        return (
                          <Card key={nomination._id} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                            <CardContent className="p-6">
                              <div className="flex flex-col sm:flex-row sm:items-start gap-4">
                                <div className="flex items-center gap-4 flex-1">
                                  <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#EC6E51] to-[#E66A4E] flex items-center justify-center text-white font-semibold text-base flex-shrink-0">
                                    {userId.username?.split(' ').map((n: string) => n[0]).join('').slice(0, 2).toUpperCase() || 'U'}
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <p className="text-lg font-semibold text-gray-900">{userId.username || 'Unknown User'}</p>
                                    <div className="flex flex-wrap items-center gap-2 mt-1">
                                      <span className="text-xs px-2.5 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                        {userId.role || 'N/A'}
                                      </span>
                                      <span className="text-xs text-gray-500">·</span>
                                      <span className="text-sm text-gray-600">{userId.email || 'N/A'}</span>
                                      {userId.phone && (
                                        <>
                                          <span className="text-xs text-gray-500">·</span>
                                          <span className="text-sm text-gray-600">{userId.phone}</span>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-1 border-t sm:border-t-0 sm:border-l border-gray-200 pt-4 sm:pt-0 pl-0 sm:pl-4">
                                  <div className="flex items-start gap-3">
                                    <Trophy className="h-5 w-5 text-yellow-600 mt-0.5 flex-shrink-0" />
                                    <div className="flex-1">
                                      <p className="text-base font-semibold text-gray-900">{award.name}</p>
                                      <p className="text-sm text-gray-600 mt-1">Category: {award.category}</p>
                                      {award.description && (
                                        <p className="text-xs text-gray-500 mt-1">{award.description}</p>
                                      )}
                                      <p className="text-xs text-gray-500 mt-2">
                                        Submitted: {nomination.createdAt ? new Date(nomination.createdAt).toLocaleString('en-IN', {
                                          year: 'numeric',
                                          month: 'short',
                                          day: 'numeric',
                                          hour: '2-digit',
                                          minute: '2-digit',
                                        }) : 'N/A'}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </CardContent>
                          </Card>
                        );
                      })
                    )}
                  </div>

                  {/* Show message if more nominations available */}
                  {filteredNominations.length > allNominationsLimit && (
                    <Card className="border border-gray-200 shadow-sm bg-blue-50">
                      <CardContent className="p-4 text-center">
                        <p className="text-sm text-gray-600">
                          Showing {allNominationsLimit} of {filteredNominations.length} nominations. 
                          {selectedAwardId && ' Filter by a specific award to see more results.'}
                        </p>
                      </CardContent>
                    </Card>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render View Result Screen (Admin only)
  const renderViewResultScreen = () => {
    // Check if user is admin
    const isAdmin = user?.role === 'ADMIN';
    const winnersLimit = isAdmin ? 10 : 3; // Show 10 for admin, 3 for others
    
    // Awards with winners yet to be announced
    const awardsWithWinnersPending = [
      'Best 30-Second Pitch Award',
      'Best LinkedIn Post Award',
      'EarlyJobs All-Rounder Award',
      'In-house Performer Award',
      'Best Content Creator Award',
      'Influencer Award',
      'Best Influencer Impact Award',
      // Team awards (ordered at the end) - All team awards are now implemented!
    ];

    // Get selected award details
    const selectedAward = selectedAwardId 
      ? allAwardsList.find(award => award._id === selectedAwardId)
      : null;

    const isWinnersPending = selectedAward && awardsWithWinnersPending.includes(selectedAward.name);
    // Check team awards first (more specific) before individual awards (more general)
    const isTeamAppDownloadsAward = selectedAward && selectedAward.name === 'Highest App Download Invitations by Team Award';
    const isTeamApproachesAward = selectedAward && selectedAward.name === 'Highest Approaches by Team Award';
    const isTeamCollegeReferralsAward = selectedAward && selectedAward.name === 'Highest College Referral by Team Award';
    const isTeamCompanyReferralsAward = selectedAward && selectedAward.name === 'Highest Company Referral by Team Award';
    const isTeamJobPostsAward = selectedAward && selectedAward.name === 'Highest Job Posts Created by Team Award';
    const isTeamJoiningsAward = selectedAward && selectedAward.name === 'Highest Joinings by Team Award';
    const isTeamSelectionsAward = selectedAward && selectedAward.name === 'Highest Selections by Team Award';
    const isTeamInternsAddedAward = selectedAward && selectedAward.name === 'Highest Number of Interns Added Award';
    const isTeamTalentPoolCreationAward = selectedAward && selectedAward.name === 'Highest Talent Pool Creation by Team Award';
    const isTeamWalkInsAward = selectedAward && selectedAward.name === 'Highest Walk-ins by Team Award';
    // Individual awards (check after team awards to avoid conflicts)
    const isApproachAward = selectedAward && selectedAward.name.toLowerCase().includes('approach') && !isTeamApproachesAward;
    const isSubjobAward = selectedAward && selectedAward.name === 'Highest Job Posts Created Award' && !isTeamJobPostsAward;
    const isCollegeReferralAward = selectedAward && selectedAward.name === 'Highest College Referral Award' && !isTeamCollegeReferralsAward;
    const isCompanyReferralAward = selectedAward && selectedAward.name === 'Highest Company Referral Award' && !isTeamCompanyReferralsAward;
    const isJoiningsAward = selectedAward && selectedAward.name === 'Highest Joinings Award' && !isTeamJoiningsAward;
    const isSelectionsAward = selectedAward && selectedAward.name === 'Highest Selections Award' && !isTeamSelectionsAward;
    const isWalkInsAward = selectedAward && selectedAward.name === 'Highest Walk-ins Award';
    const isTalentPoolAward = selectedAward && selectedAward.name === 'Highest Talent Pool Creation Award';

    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-orange-50/40 p-4 sm:p-6">
        <div className="max-w-7xl mx-auto space-y-6">
          {/* Header with Back Button */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="outline"
                onClick={() => setViewMode('main')}
                className="bg-white hover:bg-gray-50 border-gray-300"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back
              </Button>
              <div className="flex items-center gap-3">
                <Trophy className="h-6 w-6 text-[#EC6E51]" />
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                  View Result - Leading Winners
                </h1>
              </div>
            </div>
          </div>

          {/* Main Content: Awards List (Left) and Leading Winners (Right) */}
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
            {/* Awards List - Left Side */}
            <div className="lg:col-span-1">
              <Card className="border border-gray-200 shadow-sm sticky top-6">
                <CardHeader className="bg-gradient-to-r from-[#EC6E51] to-[#E66A4E] text-white rounded-t-lg py-3">
                  <CardTitle className="flex items-center gap-2 text-base">
                    <Award className="h-5 w-5" />
                    Awards ({allAwardsList.length})
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4 max-h-[calc(100vh-200px)] overflow-y-auto">
                  <div className="space-y-2">
                    <Button
                      variant={selectedAwardId === undefined ? "default" : "outline"}
                      className={`w-full justify-start ${
                        selectedAwardId === undefined 
                          ? 'bg-[#EC6E51] hover:bg-[#E66A4E] text-white' 
                          : 'bg-white hover:bg-gray-50'
                      }`}
                      onClick={() => handleAwardFilterChange(undefined)}
                    >
                      All Awards
                    </Button>
                    {(() => {
                      // Sort awards: pending awards (winners yet to be announced) at the bottom
                      const sortedAwards = [...allAwardsList].sort((a, b) => {
                        const aIsPending = awardsWithWinnersPending.includes(a.name);
                        const bIsPending = awardsWithWinnersPending.includes(b.name);
                        
                        // If both are pending or both are not pending
                        if (aIsPending === bIsPending) {
                          // If both are pending, sort by their order in awardsWithWinnersPending array
                          if (aIsPending) {
                            const aIndex = awardsWithWinnersPending.indexOf(a.name);
                            const bIndex = awardsWithWinnersPending.indexOf(b.name);
                            return aIndex - bIndex;
                          }
                          // If both are not pending, maintain original order
                          return 0;
                        }
                        
                        // Pending awards go to the bottom
                        return aIsPending ? 1 : -1;
                      });

                      return sortedAwards.map((award) => (
                        <Button
                          key={award._id}
                          variant={selectedAwardId === award._id ? "default" : "outline"}
                          className={`w-full justify-start text-left ${
                            selectedAwardId === award._id 
                              ? 'bg-[#EC6E51] hover:bg-[#E66A4E] text-white' 
                              : 'bg-white hover:bg-gray-50'
                          }`}
                          onClick={() => handleAwardFilterChange(award._id)}
                        >
                          <div className="flex flex-col items-start w-full">
                            <span className="text-sm font-medium truncate w-full">{award.name}</span>
                            <span className="text-xs opacity-75 mt-0.5">{award.category}</span>
                          </div>
                        </Button>
                      ));
                    })()}
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Dynamic Content - Right Side */}
            <div className="lg:col-span-3 space-y-6">
              {isWinnersPending ? (
                /* Winners Yet to be Announced */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-blue-50 to-indigo-50">
                    <CardHeader className="bg-gradient-to-r from-blue-100 to-indigo-100 border-b border-gray-200 rounded-t-lg py-3">
                      <CardTitle className="flex items-center gap-2 text-base text-gray-900">
                        <Award className="h-5 w-5" />
                        {selectedAward?.name}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="p-6">
                      <Card className="border border-gray-200 shadow-sm bg-white">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Award Icon */}
                            <div className="flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center bg-gradient-to-br from-gray-300 to-gray-400">
                              <Award className="h-8 w-8 text-white" />
                            </div>

                            {/* Award Info */}
                            <div className="flex-1">
                              <p className="text-lg font-semibold text-gray-900">{selectedAward?.name}</p>
                              {selectedAward?.category && (
                                <p className="text-sm text-gray-600 mt-1">Category: {selectedAward.category}</p>
                              )}
                            </div>

                            {/* Status */}
                            <div className="flex flex-col items-end">
                              <p className="text-sm font-semibold text-gray-500 italic">
                                Winners yet to be announced
                              </p>
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    </CardContent>
                  </Card>
                </>
              ) : isTeamApproachesAward ? (
                /* Team Approaches Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-green-50 to-emerald-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Team Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by team approaches (HM & FBDE teams)</p>
                        </div>
                        <Users className="h-12 w-12 text-green-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {teamApproachesWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading team approaches winners...</p>
                      </CardContent>
                    </Card>
                  ) : teamApproachesWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Users className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No team winners found</p>
                        <p className="text-sm text-gray-500">No team approaches recorded yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Team Approaches Winners List */
                    <div className="space-y-4">
                      {teamApproachesWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.teamLeaderId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* Team Leader Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.teamLeaderUsername || 'Unknown Team Leader'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.teamLeaderRole || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.teamLeaderEmail}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end gap-2">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Approaches</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.teamApproachesCount}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Size</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.teamSize}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isApproachAward ? (
                /* Approach Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-green-50 to-emerald-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Leading Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by approaches</p>
                        </div>
                        <Trophy className="h-12 w-12 text-green-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {approachWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading approach winners...</p>
                      </CardContent>
                    </Card>
                  ) : approachWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Trophy className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No winners found</p>
                        <p className="text-sm text-gray-500">No approaches recorded  yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Approach Winners List */
                    <div className="space-y-4">
                      {approachWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.userId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* User Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.username || 'Unknown User'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.role || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.email}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Approaches</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.approachesCount}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isSubjobAward ? (
                /* Subjob Post Creation Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-purple-50 to-pink-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Leading Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by subjob posts</p>
                        </div>
                        <Trophy className="h-12 w-12 text-purple-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {subjobWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading subjob winners...</p>
                      </CardContent>
                    </Card>
                  ) : subjobWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Trophy className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No winners found</p>
                        <p className="text-sm text-gray-500">No subjob posts recorded  yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Subjob Winners List */
                    <div className="space-y-4">
                      {subjobWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.userId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* User Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.username || 'Unknown User'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.role || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.email}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats */}
                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Subjob Posts</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.subjobsCount}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isJoiningsAward ? (
                /* Joinings Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-blue-50 to-cyan-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Leading Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by joinings</p>
                        </div>
                        <Trophy className="h-12 w-12 text-blue-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {joiningsWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading joinings winners...</p>
                      </CardContent>
                    </Card>
                  ) : joiningsWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Trophy className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No winners found</p>
                        <p className="text-sm text-gray-500">No joinings recorded  yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Joinings Winners List */
                    <div className="space-y-4">
                      {joiningsWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.userId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* User Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.username || 'Unknown User'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.role || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.email}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Joinings</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.joiningsCount}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isSelectionsAward ? (
                /* Selections Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-green-50 to-teal-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Leading Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by selections</p>
                        </div>
                        <Trophy className="h-12 w-12 text-green-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {selectionsWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading selections winners...</p>
                      </CardContent>
                    </Card>
                  ) : selectionsWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Trophy className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No winners found</p>
                        <p className="text-sm text-gray-500">No selections recorded  yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Selections Winners List */
                    <div className="space-y-4">
                      {selectionsWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.userId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* User Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.username || 'Unknown User'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.role || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.email}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Selections</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.selectionsCount}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isWalkInsAward ? (
                /* Walk-ins Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-indigo-50 to-purple-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Leading Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by applications added</p>
                        </div>
                        <Trophy className="h-12 w-12 text-indigo-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {walkInsWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading walk-ins winners...</p>
                      </CardContent>
                    </Card>
                  ) : walkInsWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Trophy className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No winners found</p>
                        <p className="text-sm text-gray-500">No applications recorded  yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Walk-ins Winners List */
                    <div className="space-y-4">
                      {walkInsWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.userId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* User Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.username || 'Unknown User'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.role || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.email}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Applications</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.walkInsCount}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isTalentPoolAward ? (
                /* Talent Pool Creation Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-pink-50 to-rose-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Leading Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by talent pool entries created</p>
                        </div>
                        <Trophy className="h-12 w-12 text-pink-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {talentPoolWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading talent pool winners...</p>
                      </CardContent>
                    </Card>
                  ) : talentPoolWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Trophy className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No winners found</p>
                        <p className="text-sm text-gray-500">No talent pool entries recorded  yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Talent Pool Winners List */
                    <div className="space-y-4">
                      {talentPoolWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.userId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* User Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.username || 'Unknown User'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.role || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.email}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Talent Pool Entries</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.talentPoolCount}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isCollegeReferralAward ? (
                /* College Referral Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-cyan-50 to-blue-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Leading Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by college referrals created</p>
                        </div>
                        <Trophy className="h-12 w-12 text-cyan-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {collegeReferralWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading college referral winners...</p>
                      </CardContent>
                    </Card>
                  ) : collegeReferralWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Trophy className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No winners found</p>
                        <p className="text-sm text-gray-500">No college referrals recorded  yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* College Referral Winners List */
                    <div className="space-y-4">
                      {collegeReferralWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.userId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* User Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.username || 'Unknown User'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.role || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.email}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">College Referrals</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.collegeReferralCount}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isCompanyReferralAward ? (
                /* Company Referral Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-emerald-50 to-teal-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Leading Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by company referrals created</p>
                        </div>
                        <Trophy className="h-12 w-12 text-emerald-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {companyReferralWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading company referral winners...</p>
                      </CardContent>
                    </Card>
                  ) : companyReferralWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Trophy className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No winners found</p>
                        <p className="text-sm text-gray-500">No company referrals recorded  yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Company Referral Winners List */
                    <div className="space-y-4">
                      {companyReferralWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.userId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* User Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.username || 'Unknown User'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.role || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.email}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Company Referrals</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.companyReferralCount}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isTeamCollegeReferralsAward ? (
                /* Team College Referrals Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-cyan-50 to-blue-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Team Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by team college referrals (HM & FBDE teams)</p>
                        </div>
                        <Users className="h-12 w-12 text-cyan-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {teamCollegeReferralsWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading team college referrals winners...</p>
                      </CardContent>
                    </Card>
                  ) : teamCollegeReferralsWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Users className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No team winners found</p>
                        <p className="text-sm text-gray-500">No team college referrals recorded yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Team College Referrals Winners List */
                    <div className="space-y-4">
                      {teamCollegeReferralsWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.teamLeaderId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* Team Leader Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.teamLeaderUsername || 'Unknown Team Leader'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.teamLeaderRole || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.teamLeaderEmail}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end gap-2">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team College Referrals</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.teamCollegeReferralCount}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Size</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.teamSize}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isTeamCompanyReferralsAward ? (
                /* Team Company Referrals Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-emerald-50 to-teal-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Team Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by team company referrals (HM & FBDE teams)</p>
                        </div>
                        <Users className="h-12 w-12 text-emerald-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {teamCompanyReferralsWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading team company referrals winners...</p>
                      </CardContent>
                    </Card>
                  ) : teamCompanyReferralsWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Users className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No team winners found</p>
                        <p className="text-sm text-gray-500">No team company referrals recorded yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Team Company Referrals Winners List */
                    <div className="space-y-4">
                      {teamCompanyReferralsWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.teamLeaderId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* Team Leader Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.teamLeaderUsername || 'Unknown Team Leader'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.teamLeaderRole || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.teamLeaderEmail}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end gap-2">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Company Referrals</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.teamCompanyReferralCount}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Size</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.teamSize}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isTeamJobPostsAward ? (
                /* Team Job Posts Created Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-purple-50 to-pink-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Team Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by team job posts created (HM & FBDE teams)</p>
                        </div>
                        <Users className="h-12 w-12 text-purple-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {teamJobPostsWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading team job posts winners...</p>
                      </CardContent>
                    </Card>
                  ) : teamJobPostsWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Users className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No team winners found</p>
                        <p className="text-sm text-gray-500">No team job posts recorded yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Team Job Posts Winners List */
                    <div className="space-y-4">
                      {teamJobPostsWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.teamLeaderId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* Team Leader Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.teamLeaderUsername || 'Unknown Team Leader'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.teamLeaderRole || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.teamLeaderEmail}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end gap-2">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Job Posts</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.teamJobPostsCount}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Size</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.teamSize}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isTeamJoiningsAward ? (
                /* Team Joinings Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-blue-50 to-cyan-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Team Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by team joinings (HM & FBDE teams)</p>
                        </div>
                        <Users className="h-12 w-12 text-blue-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {teamJoiningsWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading team joinings winners...</p>
                      </CardContent>
                    </Card>
                  ) : teamJoiningsWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Users className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No team winners found</p>
                        <p className="text-sm text-gray-500">No team joinings recorded yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Team Joinings Winners List */
                    <div className="space-y-4">
                      {teamJoiningsWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.teamLeaderId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* Team Leader Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.teamLeaderUsername || 'Unknown Team Leader'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.teamLeaderRole || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.teamLeaderEmail}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end gap-2">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Joinings</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.teamJoiningsCount}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Size</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.teamSize}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isTeamSelectionsAward ? (
                /* Team Selections Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-green-50 to-emerald-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Team Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by team selections (including joinings) (HM & FBDE teams)</p>
                        </div>
                        <Users className="h-12 w-12 text-green-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {teamSelectionsWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading team selections winners...</p>
                      </CardContent>
                    </Card>
                  ) : teamSelectionsWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Users className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No team winners found</p>
                        <p className="text-sm text-gray-500">No team selections recorded yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Team Selections Winners List */
                    <div className="space-y-4">
                      {teamSelectionsWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.teamLeaderId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* Team Leader Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.teamLeaderUsername || 'Unknown Team Leader'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-green-100 text-green-700 font-medium">
                                    {winner.teamLeaderRole || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.teamLeaderEmail}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end gap-2">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Selections</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.teamSelectionsCount}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Size</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.teamSize}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isTeamInternsAddedAward ? (
                /* Team Interns Added Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-purple-50 to-pink-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Team Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by team interns added (HM & FBDE teams)</p>
                        </div>
                        <Users className="h-12 w-12 text-purple-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {teamInternsAddedWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading team interns added winners...</p>
                      </CardContent>
                    </Card>
                  ) : teamInternsAddedWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Users className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No team winners found</p>
                        <p className="text-sm text-gray-500">No team interns added recorded yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Team Interns Added Winners List */
                    <div className="space-y-4">
                      {teamInternsAddedWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.teamLeaderId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* Team Leader Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.teamLeaderUsername || 'Unknown Team Leader'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-purple-100 text-purple-700 font-medium">
                                    {winner.teamLeaderRole || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.teamLeaderEmail}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end gap-2">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Interns Added</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.teamInternsAddedCount}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Size</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.teamSize}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isTeamTalentPoolCreationAward ? (
                /* Team Talent Pool Creation Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-teal-50 to-cyan-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Team Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by team talent pool creation (HM & FBDE teams)</p>
                        </div>
                        <Users className="h-12 w-12 text-teal-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {teamTalentPoolCreationWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading team talent pool creation winners...</p>
                      </CardContent>
                    </Card>
                  ) : teamTalentPoolCreationWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Users className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No team winners found</p>
                        <p className="text-sm text-gray-500">No team talent pool creation recorded yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Team Talent Pool Creation Winners List */
                    <div className="space-y-4">
                      {teamTalentPoolCreationWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.teamLeaderId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* Team Leader Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.teamLeaderUsername || 'Unknown Team Leader'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-teal-100 text-teal-700 font-medium">
                                    {winner.teamLeaderRole || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.teamLeaderEmail}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end gap-2">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Talent Pool</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.teamTalentPoolCount}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Size</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.teamSize}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isTeamWalkInsAward ? (
                /* Team Walk-ins Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-amber-50 to-yellow-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Team Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by team walk-ins (job applications) (HM & FBDE teams)</p>
                        </div>
                        <Users className="h-12 w-12 text-amber-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {teamWalkInsWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading team walk-ins winners...</p>
                      </CardContent>
                    </Card>
                  ) : teamWalkInsWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Users className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No team winners found</p>
                        <p className="text-sm text-gray-500">No team walk-ins recorded yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Team Walk-ins Winners List */
                    <div className="space-y-4">
                      {teamWalkInsWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.teamLeaderId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* Team Leader Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.teamLeaderUsername || 'Unknown Team Leader'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-amber-100 text-amber-700 font-medium">
                                    {winner.teamLeaderRole || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.teamLeaderEmail}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end gap-2">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Walk-ins</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.teamWalkInsCount}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Size</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.teamSize}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : isTeamAppDownloadsAward ? (
                /* Team App Downloads Award Winners */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-indigo-50 to-purple-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Team Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by team app downloads (HM & FBDE teams)</p>
                        </div>
                        <Users className="h-12 w-12 text-indigo-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {teamAppDownloadsWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading team app downloads winners...</p>
                      </CardContent>
                    </Card>
                  ) : teamAppDownloadsWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Users className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No team winners found</p>
                        <p className="text-sm text-gray-500">No team app downloads recorded yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Team App Downloads Winners List */
                    <div className="space-y-4">
                      {teamAppDownloadsWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.teamLeaderId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* Team Leader Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.teamLeaderUsername || 'Unknown Team Leader'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.teamLeaderRole || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.teamLeaderEmail}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end gap-2">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Downloads</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.teamDownloadsCount}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Team Size</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.teamSize}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Total Sent</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.teamTotalSent}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                /* App Downloads Winners (Default when All Awards or other awards selected) */
                <>
                  <Card className="border border-gray-200 shadow-sm bg-gradient-to-r from-yellow-50 to-orange-50">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 mb-2">🏆 Top {winnersLimit} Leading Winners</h2>
                          <p className="text-sm text-gray-600">Ranked by app downloads</p>
                        </div>
                        <Trophy className="h-12 w-12 text-yellow-500 opacity-30" />
                      </div>
                    </CardContent>
                  </Card>

                  {/* Loading State */}
                  {leadingWinnersLoading ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                        <p className="text-lg font-semibold text-gray-600">Loading leading winners...</p>
                      </CardContent>
                    </Card>
                  ) : leadingWinners.length === 0 ? (
                    <Card className="border border-gray-200 shadow-sm">
                      <CardContent className="p-12 text-center">
                        <Trophy className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-lg font-semibold text-gray-600 mb-2">No winners found</p>
                        <p className="text-sm text-gray-500">No app downloads recorded yet.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    /* Leading Winners List */
                    <div className="space-y-4">
                      {leadingWinners.slice(0, winnersLimit).map((winner, index) => (
                      <Card key={winner.userId} className="border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-4">
                            {/* Rank Badge */}
                            <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl ${
                              index === 0 
                                ? 'bg-gradient-to-br from-yellow-400 to-yellow-600' 
                                : index === 1
                                ? 'bg-gradient-to-br from-gray-300 to-gray-500'
                                : index === 2
                                ? 'bg-gradient-to-br from-orange-400 to-orange-600'
                                : 'bg-gradient-to-br from-[#EC6E51] to-[#E66A4E]'
                            }`}>
                              {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                            </div>

                            {/* User Info */}
                            <div className="flex-1">
                              <div className="mb-2">
                                <p className="text-lg font-semibold text-gray-900">{winner.username || 'Unknown User'}</p>
                                <div className="flex items-center gap-2 mt-1">
                                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700 font-medium">
                                    {winner.role || 'N/A'}
                                  </span>
                                  <span className="text-xs text-gray-500">·</span>
                                  <span className="text-sm text-gray-600">{winner.email}</span>
                                </div>
                              </div>
                            </div>

                            {/* Stats - Only show for admin */}
                            {isAdmin && (
                              <div className="flex flex-col items-end gap-2">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">App Downloads</p>
                                  <p className="text-lg font-bold text-[#EC6E51]">{winner.downloadsCount}</p>
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Total Sent</p>
                                  <p className="text-base font-semibold text-gray-700">{winner.totalSent}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </CardContent>
                      </Card>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render Registered Users Screen
  const renderRegisteredUsersScreen = () => {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-orange-50/40 p-4 sm:p-6">
        <div className="max-w-7xl mx-auto space-y-6">
          {/* Header with Back Button */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="outline"
                onClick={() => setViewMode('main')}
                className="bg-white hover:bg-gray-50 border-gray-300"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back
              </Button>
              <div className="flex items-center gap-3">
                <UserCheck className="h-6 w-6 text-[#EC6E51]" />
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                  Registered Users with Nominations
                </h1>
              </div>
            </div>
          </div>

          {/* Search Bar */}
          <Card className="border border-gray-200 shadow-sm">
            <CardContent className="p-4">
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <input
                  type="text"
                  placeholder="Search by name, email, or phone..."
                  value={registeredUsersSearch}
                  onChange={(e) => {
                    setRegisteredUsersSearch(e.target.value);
                    setRegisteredUsersPage(1);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      fetchRegisteredUsers(1, registeredUsersSearch);
                    }
                  }}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#EC6E51] focus:border-transparent"
                />
                <Button
                  onClick={() => fetchRegisteredUsers(1, registeredUsersSearch)}
                  className="bg-[#EC6E51] hover:bg-[#d55b3f] text-white"
                >
                  Search
                </Button>
                <Button
                  onClick={handleExportRegisteredUsersToExcel}
                  variant="outline"
                  className="bg-white hover:bg-gray-50 border-gray-300 text-gray-700"
                  disabled={registeredUsersLoading || (registeredUsers.length === 0 && !registeredUsersPagination)}
                >
                  <Download className="h-4 w-4 mr-2" />
                  Download Excel
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Summary Card */}
          <Card className="border border-gray-200 shadow-sm">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600 mb-1">Total Registered Users</p>
                  <p className="text-3xl font-bold text-gray-900">
                    {registeredUsersPagination?.totalResults || 0}
                  </p>
                </div>
                <UserCheck className="h-10 w-10 text-[#EC6E51] opacity-20" />
              </div>
            </CardContent>
          </Card>

          {/* Loading State */}
          {registeredUsersLoading ? (
            <Card className="border border-gray-200 shadow-sm">
              <CardContent className="p-12 text-center">
                <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                <p className="text-lg font-semibold text-gray-600">Loading registered users...</p>
              </CardContent>
            </Card>
          ) : (
            <>
              {/* Users List */}
              <div className="space-y-4">
                {registeredUsers.length === 0 ? (
                  <Card className="border border-gray-200 shadow-sm">
                    <CardContent className="p-12 text-center">
                      <UserCheck className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                      <p className="text-lg font-semibold text-gray-600 mb-2">No registered users found</p>
                      <p className="text-sm text-gray-500">
                        {registeredUsersSearch 
                          ? 'Try adjusting your search criteria.'
                          : 'No users have made nominations yet.'}
                      </p>
                    </CardContent>
                  </Card>
                ) : (
                  <Card className="border border-gray-200 shadow-sm">
                    <CardContent className="p-0">
                      <div className="overflow-x-auto">
                        <table className="w-full">
                          <thead className="bg-gray-50 border-b border-gray-200">
                            <tr>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                #
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Name
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Email
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Phone
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Role
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Nominations
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {registeredUsers.map((user, index) => (
                              <tr key={user._id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                  {(registeredUsersPage - 1) * registeredUsersLimit + index + 1}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <div className="text-sm font-medium text-gray-900">{user.username}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <div className="text-sm text-gray-900">{user.email}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <div className="text-sm text-gray-900">{user.phone || 'N/A'}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                                    {user.role}
                                  </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <div className="flex items-center">
                                    <Award className="h-4 w-4 text-[#EC6E51] mr-2" />
                                    <span className="text-sm font-medium text-gray-900">{user.nominationCount}</span>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </CardContent>
                  </Card>
                )}
              </div>

              {/* Pagination */}
              {registeredUsersPagination && registeredUsersPagination.totalPages > 1 && (
                <Card className="border border-gray-200 shadow-sm">
                  <CardContent className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="text-sm text-gray-600">
                        Showing {((registeredUsersPage - 1) * registeredUsersLimit) + 1} to{' '}
                        {Math.min(registeredUsersPage * registeredUsersLimit, registeredUsersPagination.totalResults)} of{' '}
                        {registeredUsersPagination.totalResults} users
                      </div>
                      <div className="flex gap-2">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => {
                            const newPage = registeredUsersPage - 1;
                            setRegisteredUsersPage(newPage);
                            fetchRegisteredUsers(newPage, registeredUsersSearch);
                          }}
                          disabled={registeredUsersPage === 1}
                          className="bg-white hover:bg-gray-50"
                        >
                          <ChevronLeft className="h-4 w-4 mr-1" />
                          Previous
                        </Button>
                        <div className="flex items-center gap-2">
                          <span className="text-sm text-gray-600">
                            Page {registeredUsersPage} of {registeredUsersPagination.totalPages}
                          </span>
                        </div>
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => {
                            const newPage = registeredUsersPage + 1;
                            setRegisteredUsersPage(newPage);
                            fetchRegisteredUsers(newPage, registeredUsersSearch);
                          }}
                          disabled={registeredUsersPage === registeredUsersPagination.totalPages}
                          className="bg-white hover:bg-gray-50"
                        >
                          Next
                          <ChevronRight className="h-4 w-4 ml-1" />
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  // Render Unregistered Users Screen
  const renderUnregisteredUsersScreen = () => {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-orange-50/40 p-4 sm:p-6">
        <div className="max-w-7xl mx-auto space-y-6">
          {/* Header with Back Button */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="outline"
                onClick={() => setViewMode('main')}
                className="bg-white hover:bg-gray-50 border-gray-300"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back
              </Button>
              <div className="flex items-center gap-3">
                <UserX className="h-6 w-6 text-[#EC6E51]" />
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                  Unregistered Active Users
                </h1>
              </div>
            </div>
          </div>

          {/* Search Bar */}
          <Card className="border border-gray-200 shadow-sm">
            <CardContent className="p-4">
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <input
                  type="text"
                  placeholder="Search by name, email, or phone..."
                  value={unregisteredUsersSearch}
                  onChange={(e) => {
                    setUnregisteredUsersSearch(e.target.value);
                    setUnregisteredUsersPage(1);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      fetchUnregisteredUsers(1, unregisteredUsersSearch);
                    }
                  }}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#EC6E51] focus:border-transparent"
                />
                <Button
                  onClick={() => fetchUnregisteredUsers(1, unregisteredUsersSearch)}
                  className="bg-[#EC6E51] hover:bg-[#d55b3f] text-white"
                >
                  Search
                </Button>
                <Button
                  onClick={handleExportUnregisteredUsersToExcel}
                  variant="outline"
                  className="bg-white hover:bg-gray-50 border-gray-300 text-gray-700"
                  disabled={unregisteredUsersLoading || (unregisteredUsers.length === 0 && !unregisteredUsersPagination)}
                >
                  <Download className="h-4 w-4 mr-2" />
                  Download Excel
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Summary Card */}
          <Card className="border border-gray-200 shadow-sm">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600 mb-1">Total Unregistered Active Users</p>
                  <p className="text-3xl font-bold text-gray-900">
                    {unregisteredUsersPagination?.totalResults || 0}
                  </p>
                </div>
                <UserX className="h-10 w-10 text-[#EC6E51] opacity-20" />
              </div>
            </CardContent>
          </Card>

          {/* Loading State */}
          {unregisteredUsersLoading ? (
            <Card className="border border-gray-200 shadow-sm">
              <CardContent className="p-12 text-center">
                <Loader2 className="h-16 w-16 text-[#EC6E51] mx-auto mb-4 animate-spin" />
                <p className="text-lg font-semibold text-gray-600">Loading unregistered users...</p>
              </CardContent>
            </Card>
          ) : (
            <>
              {/* Users List */}
              <div className="space-y-4">
                {unregisteredUsers.length === 0 ? (
                  <Card className="border border-gray-200 shadow-sm">
                    <CardContent className="p-12 text-center">
                      <UserX className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                      <p className="text-lg font-semibold text-gray-600 mb-2">No unregistered users found</p>
                      <p className="text-sm text-gray-500">
                        {unregisteredUsersSearch 
                          ? 'Try adjusting your search criteria.'
                          : 'No active users without nominations found.'}
                      </p>
                    </CardContent>
                  </Card>
                ) : (
                  <Card className="border border-gray-200 shadow-sm">
                    <CardContent className="p-0">
                      <div className="overflow-x-auto">
                        <table className="w-full">
                          <thead className="bg-gray-50 border-b border-gray-200">
                            <tr>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                #
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Name
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Email
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Phone
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Role
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Nominations
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {unregisteredUsers.map((user, index) => (
                              <tr key={user._id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                  {(unregisteredUsersPage - 1) * unregisteredUsersLimit + index + 1}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <div className="text-sm font-medium text-gray-900">{user.username}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <div className="text-sm text-gray-900">{user.email}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <div className="text-sm text-gray-900">{user.phone || 'N/A'}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                                    {user.role}
                                  </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <div className="flex items-center">
                                    <Award className="h-4 w-4 text-[#EC6E51] mr-2" />
                                    <span className="text-sm font-medium text-gray-900">{user.nominationCount}</span>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </CardContent>
                  </Card>
                )}
              </div>

              {/* Pagination */}
              {unregisteredUsersPagination && unregisteredUsersPagination.totalPages > 1 && (
                <Card className="border border-gray-200 shadow-sm">
                  <CardContent className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="text-sm text-gray-600">
                        Showing {((unregisteredUsersPage - 1) * unregisteredUsersLimit) + 1} to{' '}
                        {Math.min(unregisteredUsersPage * unregisteredUsersLimit, unregisteredUsersPagination.totalResults)} of{' '}
                        {unregisteredUsersPagination.totalResults} users
                      </div>
                      <div className="flex gap-2">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => {
                            const newPage = unregisteredUsersPage - 1;
                            setUnregisteredUsersPage(newPage);
                            fetchUnregisteredUsers(newPage, unregisteredUsersSearch);
                          }}
                          disabled={unregisteredUsersPage === 1}
                          className="bg-white hover:bg-gray-50"
                        >
                          <ChevronLeft className="h-4 w-4 mr-1" />
                          Previous
                        </Button>
                        <div className="flex items-center gap-2">
                          <span className="text-sm text-gray-600">
                            Page {unregisteredUsersPage} of {unregisteredUsersPagination.totalPages}
                          </span>
                        </div>
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => {
                            const newPage = unregisteredUsersPage + 1;
                            setUnregisteredUsersPage(newPage);
                            fetchUnregisteredUsers(newPage, unregisteredUsersSearch);
                          }}
                          disabled={unregisteredUsersPage === unregisteredUsersPagination.totalPages}
                          className="bg-white hover:bg-gray-50"
                        >
                          Next
                          <ChevronRight className="h-4 w-4 ml-1" />
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  // Show team nominations screen if viewMode is set
  if (viewMode === 'teamNominations') {
    return renderTeamNominationsScreen();
  }

  // Show all nominations screen if viewMode is set
  if (viewMode === 'allNominations') {
    return renderAllNominationsScreen();
  }

  // Show view result screen if viewMode is set
  if (viewMode === 'viewResult') {
    return renderViewResultScreen();
  }

  // Show registered users screen if viewMode is set
  if (viewMode === 'registeredUsers') {
    return renderRegisteredUsersScreen();
  }

  // Show unregistered users screen if viewMode is set
  if (viewMode === 'unregisteredUsers') {
    return renderUnregisteredUsersScreen();
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-orange-50/40 p-4 sm:p-6 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-12 w-12 animate-spin text-[#EC6E51] mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Show submitted nominations if user has already submitted
  if (user?.isMahkumbnominationSubmitted || submittedNominations.length > 0) {
    return renderSubmittedNominations();
  }

  // Check if user has permission to view team nominations
  const canViewTeamNominations = user?.role === 'ADMIN' || user?.role === 'SHM' || user?.role === 'FBDE' || user?.role === 'HM' || user?.role === 'AGENCY';

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-orange-50/40 p-4 sm:p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-4 mb-4">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
              🏆 Recruitment Mahakumb Awards
            </h1>
            {canViewTeamNominations && (
              <Button
                variant="outline"
                className="bg-white hover:bg-gray-50 border-gray-300 text-gray-700"
                onClick={() => setViewMode('teamNominations')}
              >
                <Users className="h-4 w-4 mr-2" />
                My Team Nominations
              </Button>
            )}
          </div>
          <p className="text-gray-600">Select the award categories you want to participate in</p>
        </div>

        {/* Individual Winner Categories */}
        <Card className="shadow-lg border-2 border-gray-200">
          <CardHeader className="bg-gradient-to-r from-[#EC6E51] to-[#E66A4E] text-white rounded-t-lg">
            <CardTitle className="flex items-center gap-2 text-xl sm:text-2xl">
              <Trophy className="h-6 w-6" />
              Individual Winner Categories
            </CardTitle>
          </CardHeader>
          <CardContent className="p-4 sm:p-6">
            <div className="space-y-3">
              {individualAwards.map((award, index) => (
                <div
                  key={award.id}
                  className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <Checkbox
                    id={award.id}
                    checked={award.checked}
                    onCheckedChange={(checked) =>
                      handleIndividualChange(award.id, checked as boolean)
                    }
                    className="h-5 w-5"
                  />
                  <label
                    htmlFor={award.id}
                    className="flex-1 text-sm sm:text-base font-medium text-gray-700 cursor-pointer"
                  >
                    <span className="text-gray-600 font-semibold mr-2">{index + 1}.</span>
                    {award.name}
                  </label>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Team Winner Categories */}
        <Card className="shadow-lg border-2 border-gray-200">
          <CardHeader className="bg-gradient-to-r from-[#EC6E51] to-[#E66A4E] text-white rounded-t-lg">
            <CardTitle className="flex items-center gap-2 text-xl sm:text-2xl">
              <Users className="h-6 w-6" />
              🤝 Team Winner Categories
            </CardTitle>
          </CardHeader>
          <CardContent className="p-4 sm:p-6">
            <div className="space-y-3">
              {teamAwards.map((award, index) => (
                <div
                  key={award.id}
                  className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <Checkbox
                    id={award.id}
                    checked={award.checked}
                    onCheckedChange={(checked) =>
                      handleTeamChange(award.id, checked as boolean)
                    }
                    className="h-5 w-5"
                  />
                  <label
                    htmlFor={award.id}
                    className="flex-1 text-sm sm:text-base font-medium text-gray-700 cursor-pointer"
                  >
                    <span className="text-gray-600 font-semibold mr-2">{index + 1}.</span>
                    {award.name}
                  </label>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Influencer Award Categories */}
        <Card className="shadow-lg border-2 border-gray-200">
          <CardHeader className="bg-gradient-to-r from-[#EC6E51] to-[#E66A4E] text-white rounded-t-lg">
            <CardTitle className="flex items-center gap-2 text-xl sm:text-2xl">
              <Star className="h-6 w-6" />
              🌟 Influencer Award Categories
            </CardTitle>
          </CardHeader>
          <CardContent className="p-4 sm:p-6">
            <div className="space-y-4">
              {influencerAwards.map((award, index) => (
                <div
                  key={award.id}
                  className="p-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-start space-x-3">
                    <Checkbox
                      id={award.id}
                      checked={award.checked}
                      onCheckedChange={(checked) =>
                        handleInfluencerChange(award.id, checked as boolean)
                      }
                      className="h-5 w-5 mt-0.5"
                    />
                    <div className="flex-1">
                      <label
                        htmlFor={award.id}
                        className="text-sm sm:text-base font-medium text-gray-700 cursor-pointer block"
                      >
                        <span className="text-gray-600 font-semibold mr-2">{index + 1}.</span>
                        {award.name}
                      </label>
                      {award.description && (
                        <p className="text-xs sm:text-sm text-gray-500 mt-1 ml-6">
                          ({award.description})
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Common Awards */}
        <Card className="shadow-lg border-2 border-gray-200">
          <CardHeader className="bg-gradient-to-r from-[#EC6E51] to-[#E66A4E] text-white rounded-t-lg">
            <CardTitle className="flex items-center gap-2 text-xl sm:text-2xl">
              <Award className="h-6 w-6" />
              🌟 Common Awards (For All Categories)
            </CardTitle>
          </CardHeader>
          <CardContent className="p-4 sm:p-6">
            <div className="space-y-3">
              {commonAwards
                .filter(award => {
                  // Show "In-house Performer Award" only to INTERNAL_TEAM role
                  if (award.name === 'In-house Performer Award') {
                    return user?.role === 'INTERNAL_TEAM';
                  }
                  return true;
                })
                .map((award, index) => (
                  <div
                    key={award.id}
                    className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <Checkbox
                      id={award.id}
                      checked={award.checked}
                      onCheckedChange={(checked) =>
                        handleCommonChange(award.id, checked as boolean)
                      }
                      className="h-5 w-5"
                    />
                    <label
                      htmlFor={award.id}
                      className="flex-1 text-sm sm:text-base font-medium text-gray-700 cursor-pointer"
                    >
                      <span className="text-gray-600 font-semibold mr-2">{index + 1}.</span>
                      {award.name}
                    </label>
                  </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Submit Button */}
        <div className="flex justify-center pt-6">
          <Button
            onClick={handleSubmitNominations}
            disabled={submitting}
            className="bg-gradient-to-r from-[#EC6E51] to-[#E66A4E] hover:from-[#E66A4E] hover:to-[#EC6E51] text-white px-8 py-6 text-lg font-semibold rounded-lg shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            size="lg"
          >
            {submitting ? (
              <>
                <Loader2 className="h-5 w-5 mr-2 animate-spin" />
                Submitting...
              </>
            ) : (
              <>
                <Check className="h-5 w-5 mr-2" />
                Submit Nominations
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RecruitmentMahakumb;

